// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#stars {
  width: 1px;
  height: 1px;
  background: transparent;
  z-index: -100;
  animation: animStar 50s linear infinite;
  box-shadow:
    779px 1331px #fff,
    324px 42px #fff,
    303px 586px #fff,
    1312px 276px #fff,
    451px 625px #fff,
    521px 1931px #fff,
    1087px 1871px #fff,
    36px 1546px #fff,
    132px 934px #fff,
    1698px 901px #fff,
    1418px 664px #fff,
    1448px 1157px #fff,
    1084px 232px #fff,
    347px 1776px #fff,
    1722px 243px #fff,
    1629px 835px #fff,
    479px 969px #fff,
    1231px 960px #fff,
    586px 384px #fff,
    164px 527px #fff,
    8px 646px #fff,
    1150px 1126px #fff,
    665px 1357px #fff,
    1556px 1982px #fff,
    1260px 1961px #fff,
    1675px 1741px #fff,
    1843px 1514px #fff,
    718px 1628px #fff,
    242px 1343px #fff,
    1497px 1880px #fff,
    1364px 230px #fff,
    1739px 1302px #fff,
    636px 959px #fff,
    304px 686px #fff,
    614px 751px #fff,
    1935px 816px #fff,
    1428px 60px #fff,
    355px 335px #fff,
    1594px 158px #fff,
    90px 60px #fff,
    1553px 162px #fff,
    1239px 1825px #fff,
    1945px 587px #fff,
    749px 1785px #fff,
    1987px 1172px #fff,
    1301px 1237px #fff,
    1039px 342px #fff,
    1585px 1481px #fff,
    995px 1048px #fff,
    524px 932px #fff,
    214px 413px #fff,
    1701px 1300px #fff,
    1037px 1613px #fff,
    1871px 996px #fff,
    1360px 1635px #fff,
    1110px 1313px #fff,
    412px 1783px #fff,
    1949px 177px #fff,
    903px 1854px #fff,
    700px 1936px #fff,
    378px 125px #fff,
    308px 834px #fff,
    1118px 962px #fff,
    1350px 1929px #fff,
    781px 1811px #fff,
    561px 137px #fff,
    757px 1148px #fff,
    1670px 1979px #fff,
    343px 739px #fff,
    945px 795px #fff,
    576px 1903px #fff,
    1078px 1436px #fff,
    1583px 450px #fff,
    1366px 474px #fff,
    297px 1873px #fff,
    192px 162px #fff,
    1624px 1633px #fff,
    59px 453px #fff,
    82px 1872px #fff,
    1933px 498px #fff,
    1966px 1974px #fff,
    1975px 1688px #fff,
    779px 314px #fff,
    1858px 1543px #fff,
    73px 1507px #fff,
    1693px 975px #fff,
    1683px 108px #fff,
    1768px 1654px #fff,
    654px 14px #fff,
    494px 171px #fff,
    1689px 1895px #fff,
    1660px 263px #fff,
    1031px 903px #fff,
    1203px 1393px #fff,
    1333px 1421px #fff,
    1113px 41px #fff,
    1206px 1645px #fff,
    1325px 1635px #fff,
    142px 388px #fff,
    572px 215px #fff,
    1535px 296px #fff,
    1419px 407px #fff,
    1379px 1003px #fff,
    329px 469px #fff,
    1791px 1652px #fff,
    935px 1802px #fff,
    1330px 1820px #fff,
    421px 1933px #fff,
    828px 365px #fff,
    275px 316px #fff,
    707px 960px #fff,
    1605px 1554px #fff,
    625px 58px #fff,
    717px 1697px #fff,
    1669px 246px #fff,
    1925px 322px #fff,
    1154px 1803px #fff,
    1929px 295px #fff,
    1248px 240px #fff,
    1045px 1755px #fff,
    166px 942px #fff,
    1888px 1773px #fff,
    678px 1963px #fff,
    1370px 569px #fff,
    1974px 1400px #fff,
    1786px 460px #fff,
    51px 307px #fff,
    784px 1400px #fff,
    730px 1258px #fff,
    1712px 393px #fff,
    416px 170px #fff,
    1797px 1932px #fff,
    572px 219px #fff,
    1557px 1856px #fff,
    218px 8px #fff,
    348px 1334px #fff,
    469px 413px #fff,
    385px 1738px #fff,
    1357px 1818px #fff,
    240px 942px #fff,
    248px 1847px #fff,
    1535px 806px #fff,
    236px 1514px #fff,
    1429px 1556px #fff,
    73px 1633px #fff,
    1398px 1121px #fff,
    671px 1301px #fff,
    1404px 1663px #fff,
    740px 1018px #fff,
    1600px 377px #fff,
    785px 514px #fff,
    112px 1084px #fff,
    1915px 1887px #fff,
    1463px 1848px #fff,
    687px 1115px #fff,
    1268px 1768px #fff,
    1729px 1425px #fff,
    1284px 1022px #fff,
    801px 974px #fff,
    1975px 1317px #fff,
    1354px 834px #fff,
    1446px 1484px #fff,
    1283px 1786px #fff,
    11px 523px #fff,
    1842px 236px #fff,
    1355px 654px #fff,
    429px 7px #fff,
    1033px 1128px #fff,
    157px 297px #fff,
    545px 635px #fff,
    52px 1080px #fff,
    827px 1520px #fff,
    1121px 490px #fff,
    9px 309px #fff,
    1744px 1586px #fff,
    1014px 417px #fff,
    1534px 524px #fff,
    958px 552px #fff,
    1403px 1496px #fff,
    387px 703px #fff,
    1522px 548px #fff,
    1355px 282px #fff,
    1532px 601px #fff,
    1838px 790px #fff,
    290px 259px #fff,
    295px 598px #fff,
    1601px 539px #fff,
    1561px 1272px #fff,
    34px 1922px #fff,
    1024px 543px #fff,
    467px 369px #fff,
    722px 333px #fff,
    1976px 1255px #fff,
    766px 983px #fff,
    1582px 1285px #fff,
    12px 512px #fff,
    617px 1410px #fff,
    682px 577px #fff,
    1334px 1438px #fff,
    439px 327px #fff,
    1617px 1661px #fff,
    673px 129px #fff,
    794px 941px #fff,
    1386px 1902px #fff,
    37px 1353px #fff,
    1467px 1353px #fff,
    416px 18px #fff,
    187px 344px #fff,
    200px 1898px #fff,
    1491px 1619px #fff,
    811px 347px #fff,
    924px 1827px #fff,
    945px 217px #fff,
    1735px 1228px #fff,
    379px 1890px #fff,
    79px 761px #fff,
    825px 1837px #fff,
    1980px 1558px #fff,
    1308px 1573px #fff,
    1488px 1726px #fff,
    382px 1208px #fff,
    522px 595px #fff,
    1277px 1898px #fff,
    354px 552px #fff,
    161px 1784px #fff,
    614px 251px #fff,
    526px 1576px #fff,
    17px 212px #fff,
    179px 996px #fff,
    467px 1208px #fff,
    1944px 1838px #fff,
    1140px 1093px #fff,
    858px 1007px #fff,
    200px 1064px #fff,
    423px 1964px #fff,
    1945px 439px #fff,
    1377px 689px #fff,
    1120px 1437px #fff,
    1876px 668px #fff,
    907px 1324px #fff,
    343px 1976px #fff,
    1816px 1501px #fff,
    1849px 177px #fff,
    647px 91px #fff,
    1984px 1012px #fff,
    1336px 1300px #fff,
    128px 648px #fff,
    305px 1060px #fff,
    1324px 826px #fff,
    1263px 1314px #fff,
    1801px 629px #fff,
    1614px 1555px #fff,
    1634px 90px #fff,
    1603px 452px #fff,
    891px 1984px #fff,
    1556px 1906px #fff,
    121px 68px #fff,
    1676px 1714px #fff,
    516px 936px #fff,
    1947px 1492px #fff,
    1455px 1519px #fff,
    45px 602px #fff,
    205px 1039px #fff,
    793px 172px #fff,
    1562px 1739px #fff,
    1056px 110px #fff,
    1512px 379px #fff,
    1795px 1621px #fff,
    1848px 607px #fff,
    262px 1719px #fff,
    477px 991px #fff,
    483px 883px #fff,
    1239px 1197px #fff,
    1496px 647px #fff,
    1649px 25px #fff,
    1491px 1946px #fff,
    119px 996px #fff,
    179px 1472px #fff,
    1341px 808px #fff,
    1565px 1700px #fff,
    407px 1544px #fff,
    1754px 357px #fff,
    1288px 981px #fff,
    902px 1997px #fff,
    1755px 1668px #fff,
    186px 877px #fff,
    1202px 1882px #fff,
    461px 1213px #fff,
    1400px 748px #fff,
    1969px 1899px #fff,
    809px 522px #fff,
    514px 1219px #fff,
    374px 275px #fff,
    938px 1973px #fff,
    357px 552px #fff,
    144px 1722px #fff,
    1572px 912px #fff,
    402px 1858px #fff,
    1544px 1195px #fff,
    667px 1257px #fff,
    727px 1496px #fff,
    993px 232px #fff,
    1772px 313px #fff,
    1040px 1590px #fff,
    1204px 1973px #fff,
    1268px 79px #fff,
    1555px 1048px #fff,
    986px 1707px #fff,
    978px 1710px #fff,
    713px 360px #fff,
    407px 863px #fff,
    461px 736px #fff,
    284px 1608px #fff,
    103px 430px #fff,
    1283px 1319px #fff,
    977px 1186px #fff,
    1966px 1516px #fff,
    1287px 1129px #fff,
    70px 1098px #fff,
    1189px 889px #fff,
    1126px 1734px #fff,
    309px 1292px #fff,
    879px 764px #fff,
    65px 473px #fff,
    1003px 1959px #fff,
    658px 791px #fff,
    402px 1576px #fff,
    35px 622px #fff,
    529px 1589px #fff,
    164px 666px #fff,
    1876px 1290px #fff,
    1541px 526px #fff,
    270px 1297px #fff,
    440px 865px #fff,
    1500px 802px #fff,
    182px 1754px #fff,
    1264px 892px #fff,
    272px 1249px #fff,
    1289px 1535px #fff,
    190px 1646px #fff,
    955px 242px #fff,
    1456px 1597px #fff,
    1727px 1983px #fff,
    635px 801px #fff,
    226px 455px #fff,
    1396px 1710px #fff,
    849px 1863px #fff,
    237px 1264px #fff,
    839px 140px #fff,
    1122px 735px #fff,
    1280px 15px #fff,
    1318px 242px #fff,
    1819px 1148px #fff,
    333px 1392px #fff,
    1949px 553px #fff,
    1878px 1332px #fff,
    467px 548px #fff,
    1812px 1082px #fff,
    1067px 193px #fff,
    243px 156px #fff,
    483px 1616px #fff,
    1714px 933px #fff,
    759px 1800px #fff,
    1822px 995px #fff,
    1877px 572px #fff,
    581px 1084px #fff,
    107px 732px #fff,
    642px 1837px #fff,
    166px 1493px #fff,
    1555px 198px #fff,
    819px 307px #fff,
    947px 345px #fff,
    827px 224px #fff,
    927px 1394px #fff,
    540px 467px #fff,
    1093px 405px #fff,
    1140px 927px #fff,
    130px 529px #fff,
    33px 1980px #fff,
    1147px 1663px #fff,
    1616px 1436px #fff,
    528px 710px #fff,
    798px 1100px #fff,
    505px 1480px #fff,
    899px 641px #fff,
    1909px 1949px #fff,
    1311px 964px #fff,
    979px 1301px #fff,
    1393px 969px #fff,
    1793px 1886px #fff,
    292px 357px #fff,
    1196px 1718px #fff,
    1290px 1994px #fff,
    537px 1973px #fff,
    1181px 1674px #fff,
    1740px 1566px #fff,
    1307px 265px #fff,
    922px 522px #fff,
    1892px 472px #fff,
    384px 1746px #fff,
    392px 1098px #fff,
    647px 548px #fff,
    390px 1498px #fff,
    1246px 138px #fff,
    730px 876px #fff,
    192px 1472px #fff,
    1790px 1789px #fff,
    928px 311px #fff,
    1253px 1647px #fff,
    747px 1921px #fff,
    1561px 1025px #fff,
    1533px 1292px #fff,
    1985px 195px #fff,
    728px 729px #fff,
    1712px 1936px #fff,
    512px 1717px #fff,
    1528px 483px #fff,
    313px 1642px #fff,
    281px 1849px #fff,
    1212px 799px #fff,
    435px 1191px #fff,
    1422px 611px #fff,
    1718px 1964px #fff,
    411px 944px #fff,
    210px 636px #fff,
    1502px 1295px #fff,
    1434px 349px #fff,
    769px 60px #fff,
    747px 1053px #fff,
    789px 504px #fff,
    1436px 1264px #fff,
    1893px 1225px #fff,
    1394px 1788px #fff,
    1108px 1317px #fff,
    1673px 1395px #fff,
    854px 1010px #fff,
    1705px 80px #fff,
    1858px 148px #fff,
    1729px 344px #fff,
    1388px 664px #fff,
    895px 406px #fff,
    1479px 157px #fff,
    1441px 1157px #fff,
    552px 1900px #fff,
    516px 364px #fff,
    1647px 189px #fff,
    1427px 1071px #fff,
    785px 729px #fff,
    1080px 1710px #fff,
    504px 204px #fff,
    1177px 1622px #fff,
    657px 34px #fff,
    1296px 1099px #fff,
    248px 180px #fff,
    1212px 1568px #fff,
    667px 1562px #fff,
    695px 841px #fff,
    1608px 1247px #fff,
    751px 882px #fff,
    87px 167px #fff,
    607px 1368px #fff,
    1363px 1203px #fff,
    1836px 317px #fff,
    1668px 1703px #fff,
    830px 1154px #fff,
    1721px 1398px #fff,
    1601px 1280px #fff,
    976px 874px #fff,
    1743px 254px #fff,
    1020px 1815px #fff,
    1670px 1766px #fff,
    1890px 735px #fff,
    1379px 136px #fff,
    1864px 695px #fff,
    206px 965px #fff,
    1404px 1932px #fff,
    1923px 1360px #fff,
    247px 682px #fff,
    519px 1708px #fff,
    645px 750px #fff,
    1164px 1204px #fff,
    834px 323px #fff,
    172px 1350px #fff,
    213px 972px #fff,
    1837px 190px #fff,
    285px 1806px #fff,
    1047px 1299px #fff,
    1548px 825px #fff,
    1730px 324px #fff,
    1346px 1909px #fff,
    772px 270px #fff,
    345px 1190px #fff,
    478px 1433px #fff,
    1479px 25px #fff,
    1994px 1830px #fff,
    1744px 732px #fff,
    20px 1635px #fff,
    690px 1795px #fff,
    1594px 569px #fff,
    579px 245px #fff,
    1398px 733px #fff,
    408px 1352px #fff,
    1774px 120px #fff,
    1152px 1370px #fff,
    1698px 1810px #fff,
    710px 1450px #fff,
    665px 286px #fff,
    493px 1720px #fff,
    786px 5px #fff,
    637px 1140px #fff,
    764px 324px #fff,
    927px 310px #fff,
    938px 1424px #fff,
    1884px 744px #fff,
    913px 462px #fff,
    1831px 1936px #fff,
    1527px 249px #fff,
    36px 1381px #fff,
    1597px 581px #fff,
    1530px 355px #fff,
    949px 459px #fff,
    799px 828px #fff,
    242px 1471px #fff,
    654px 797px #fff,
    796px 594px #fff,
    1365px 678px #fff,
    752px 23px #fff,
    1630px 541px #fff,
    982px 72px #fff,
    1733px 1831px #fff,
    21px 412px #fff,
    775px 998px #fff,
    335px 1945px #fff,
    264px 583px #fff,
    158px 1311px #fff,
    528px 164px #fff,
    1978px 574px #fff,
    717px 1203px #fff,
    734px 1591px #fff,
    1555px 820px #fff,
    16px 1943px #fff,
    1625px 1177px #fff,
    1236px 690px #fff,
    1585px 1590px #fff,
    1737px 1728px #fff,
    721px 698px #fff,
    1804px 1186px #fff,
    166px 980px #fff,
    1850px 230px #fff,
    330px 1712px #fff,
    95px 797px #fff,
    1948px 1078px #fff,
    469px 939px #fff,
    1269px 1899px #fff,
    955px 1220px #fff,
    1137px 1075px #fff,
    312px 1293px #fff,
    986px 1762px #fff,
    1103px 1238px #fff,
    428px 1993px #fff,
    355px 570px #fff,
    977px 1836px #fff,
    1395px 1092px #fff,
    276px 913px #fff,
    1743px 656px #fff,
    773px 502px #fff,
    1686px 1322px #fff,
    1516px 1945px #fff,
    1334px 501px #fff,
    266px 156px #fff,
    455px 655px #fff,
    798px 72px #fff,
    1059px 1259px #fff,
    1402px 1687px #fff,
    236px 1329px #fff,
    1455px 786px #fff,
    146px 1228px #fff,
    1851px 823px #fff,
    1062px 100px #fff,
    1220px 953px #fff,
    20px 1826px #fff,
    36px 1063px #fff,
    1525px 338px #fff,
    790px 1521px #fff,
    741px 1099px #fff,
    288px 1489px #fff,
    700px 1060px #fff,
    390px 1071px #fff,
    411px 1036px #fff,
    1853px 1072px #fff,
    1446px 1085px #fff,
    1164px 874px #fff,
    924px 925px #fff,
    291px 271px #fff,
    1257px 1964px #fff,
    1580px 1352px #fff,
    1507px 1216px #fff,
    211px 956px #fff,
    985px 1195px #fff,
    975px 1640px #fff,
    518px 101px #fff,
    663px 1395px #fff,
    914px 532px #fff,
    145px 1320px #fff,
    69px 1397px #fff,
    982px 523px #fff,
    257px 725px #fff,
    1599px 831px #fff,
    1636px 1513px #fff,
    1250px 1158px #fff,
    1132px 604px #fff,
    183px 102px #fff,
    1057px 318px #fff,
    1247px 1835px #fff,
    1983px 1110px #fff,
    1077px 1455px #fff,
    921px 1770px #fff,
    806px 1350px #fff,
    1938px 1992px #fff,
    855px 1260px #fff,
    902px 1345px #fff,
    658px 1908px #fff,
    1845px 679px #fff,
    712px 1482px #fff,
    595px 950px #fff,
    1784px 1992px #fff,
    1847px 1785px #fff,
    691px 1004px #fff,
    175px 1179px #fff,
    1666px 1911px #fff,
    41px 61px #fff,
    971px 1080px #fff,
    1830px 1450px #fff,
    1351px 1518px #fff,
    1257px 99px #fff,
    1395px 1498px #fff,
    1117px 252px #fff,
    1779px 597px #fff,
    1346px 729px #fff,
    1108px 1144px #fff,
    402px 691px #fff,
    72px 496px #fff,
    1673px 1604px #fff,
    1497px 974px #fff,
    1865px 1664px #fff,
    88px 806px #fff,
    918px 77px #fff,
    244px 1118px #fff,
    256px 1820px #fff,
    1851px 1840px #fff,
    605px 1851px #fff,
    634px 383px #fff,
    865px 37px #fff,
    943px 1024px #fff,
    1951px 177px #fff,
    1097px 523px #fff,
    985px 1700px #fff,
    1243px 122px #fff,
    768px 1070px #fff,
    468px 194px #fff,
    320px 1867px #fff,
    1850px 185px #fff,
    380px 1616px #fff,
    468px 1294px #fff,
    1122px 1743px #fff,
    884px 299px #fff,
    1300px 1917px #fff,
    1860px 396px #fff,
    1270px 990px #fff,
    529px 733px #fff,
    1975px 1347px #fff,
    1885px 685px #fff,
    226px 506px #fff,
    651px 878px #fff,
    1323px 680px #fff,
    1284px 680px #fff,
    238px 1967px #fff,
    911px 174px #fff,
    1111px 521px #fff,
    1150px 85px #fff,
    794px 502px #fff,
    484px 1856px #fff,
    1809px 368px #fff,
    112px 953px #fff,
    590px 1009px #fff,
    1655px 311px #fff,
    100px 1026px #fff,
    1803px 352px #fff,
    865px 306px #fff,
    1077px 1019px #fff,
    1335px 872px #fff,
    1647px 1298px #fff,
    1233px 1387px #fff,
    698px 1036px #fff,
    659px 1860px #fff,
    388px 1412px #fff,
    1212px 458px #fff,
    755px 1468px #fff,
    696px 1654px #fff,
    1144px 60px #fff;
}

#stars:after {
  content: "";
  position: absolute;
  top: 2000px;
  width: 1px;
  height: 1px;
  background: transparent;
  box-shadow:
    779px 1331px #fff,
    324px 42px #fff,
    303px 586px #fff,
    1312px 276px #fff,
    451px 625px #fff,
    521px 1931px #fff,
    1087px 1871px #fff,
    36px 1546px #fff,
    132px 934px #fff,
    1698px 901px #fff,
    1418px 664px #fff,
    1448px 1157px #fff,
    1084px 232px #fff,
    347px 1776px #fff,
    1722px 243px #fff,
    1629px 835px #fff,
    479px 969px #fff,
    1231px 960px #fff,
    586px 384px #fff,
    164px 527px #fff,
    8px 646px #fff,
    1150px 1126px #fff,
    665px 1357px #fff,
    1556px 1982px #fff,
    1260px 1961px #fff,
    1675px 1741px #fff,
    1843px 1514px #fff,
    718px 1628px #fff,
    242px 1343px #fff,
    1497px 1880px #fff,
    1364px 230px #fff,
    1739px 1302px #fff,
    636px 959px #fff,
    304px 686px #fff,
    614px 751px #fff,
    1935px 816px #fff,
    1428px 60px #fff,
    355px 335px #fff,
    1594px 158px #fff,
    90px 60px #fff,
    1553px 162px #fff,
    1239px 1825px #fff,
    1945px 587px #fff,
    749px 1785px #fff,
    1987px 1172px #fff,
    1301px 1237px #fff,
    1039px 342px #fff,
    1585px 1481px #fff,
    995px 1048px #fff,
    524px 932px #fff,
    214px 413px #fff,
    1701px 1300px #fff,
    1037px 1613px #fff,
    1871px 996px #fff,
    1360px 1635px #fff,
    1110px 1313px #fff,
    412px 1783px #fff,
    1949px 177px #fff,
    903px 1854px #fff,
    700px 1936px #fff,
    378px 125px #fff,
    308px 834px #fff,
    1118px 962px #fff,
    1350px 1929px #fff,
    781px 1811px #fff,
    561px 137px #fff,
    757px 1148px #fff,
    1670px 1979px #fff,
    343px 739px #fff,
    945px 795px #fff,
    576px 1903px #fff,
    1078px 1436px #fff,
    1583px 450px #fff,
    1366px 474px #fff,
    297px 1873px #fff,
    192px 162px #fff,
    1624px 1633px #fff,
    59px 453px #fff,
    82px 1872px #fff,
    1933px 498px #fff,
    1966px 1974px #fff,
    1975px 1688px #fff,
    779px 314px #fff,
    1858px 1543px #fff,
    73px 1507px #fff,
    1693px 975px #fff,
    1683px 108px #fff,
    1768px 1654px #fff,
    654px 14px #fff,
    494px 171px #fff,
    1689px 1895px #fff,
    1660px 263px #fff,
    1031px 903px #fff,
    1203px 1393px #fff,
    1333px 1421px #fff,
    1113px 41px #fff,
    1206px 1645px #fff,
    1325px 1635px #fff,
    142px 388px #fff,
    572px 215px #fff,
    1535px 296px #fff,
    1419px 407px #fff,
    1379px 1003px #fff,
    329px 469px #fff,
    1791px 1652px #fff,
    935px 1802px #fff,
    1330px 1820px #fff,
    421px 1933px #fff,
    828px 365px #fff,
    275px 316px #fff,
    707px 960px #fff,
    1605px 1554px #fff,
    625px 58px #fff,
    717px 1697px #fff,
    1669px 246px #fff,
    1925px 322px #fff,
    1154px 1803px #fff,
    1929px 295px #fff,
    1248px 240px #fff,
    1045px 1755px #fff,
    166px 942px #fff,
    1888px 1773px #fff,
    678px 1963px #fff,
    1370px 569px #fff,
    1974px 1400px #fff,
    1786px 460px #fff,
    51px 307px #fff,
    784px 1400px #fff,
    730px 1258px #fff,
    1712px 393px #fff,
    416px 170px #fff,
    1797px 1932px #fff,
    572px 219px #fff,
    1557px 1856px #fff,
    218px 8px #fff,
    348px 1334px #fff,
    469px 413px #fff,
    385px 1738px #fff,
    1357px 1818px #fff,
    240px 942px #fff,
    248px 1847px #fff,
    1535px 806px #fff,
    236px 1514px #fff,
    1429px 1556px #fff,
    73px 1633px #fff,
    1398px 1121px #fff,
    671px 1301px #fff,
    1404px 1663px #fff,
    740px 1018px #fff,
    1600px 377px #fff,
    785px 514px #fff,
    112px 1084px #fff,
    1915px 1887px #fff,
    1463px 1848px #fff,
    687px 1115px #fff,
    1268px 1768px #fff,
    1729px 1425px #fff,
    1284px 1022px #fff,
    801px 974px #fff,
    1975px 1317px #fff,
    1354px 834px #fff,
    1446px 1484px #fff,
    1283px 1786px #fff,
    11px 523px #fff,
    1842px 236px #fff,
    1355px 654px #fff,
    429px 7px #fff,
    1033px 1128px #fff,
    157px 297px #fff,
    545px 635px #fff,
    52px 1080px #fff,
    827px 1520px #fff,
    1121px 490px #fff,
    9px 309px #fff,
    1744px 1586px #fff,
    1014px 417px #fff,
    1534px 524px #fff,
    958px 552px #fff,
    1403px 1496px #fff,
    387px 703px #fff,
    1522px 548px #fff,
    1355px 282px #fff,
    1532px 601px #fff,
    1838px 790px #fff,
    290px 259px #fff,
    295px 598px #fff,
    1601px 539px #fff,
    1561px 1272px #fff,
    34px 1922px #fff,
    1024px 543px #fff,
    467px 369px #fff,
    722px 333px #fff,
    1976px 1255px #fff,
    766px 983px #fff,
    1582px 1285px #fff,
    12px 512px #fff,
    617px 1410px #fff,
    682px 577px #fff,
    1334px 1438px #fff,
    439px 327px #fff,
    1617px 1661px #fff,
    673px 129px #fff,
    794px 941px #fff,
    1386px 1902px #fff,
    37px 1353px #fff,
    1467px 1353px #fff,
    416px 18px #fff,
    187px 344px #fff,
    200px 1898px #fff,
    1491px 1619px #fff,
    811px 347px #fff,
    924px 1827px #fff,
    945px 217px #fff,
    1735px 1228px #fff,
    379px 1890px #fff,
    79px 761px #fff,
    825px 1837px #fff,
    1980px 1558px #fff,
    1308px 1573px #fff,
    1488px 1726px #fff,
    382px 1208px #fff,
    522px 595px #fff,
    1277px 1898px #fff,
    354px 552px #fff,
    161px 1784px #fff,
    614px 251px #fff,
    526px 1576px #fff,
    17px 212px #fff,
    179px 996px #fff,
    467px 1208px #fff,
    1944px 1838px #fff,
    1140px 1093px #fff,
    858px 1007px #fff,
    200px 1064px #fff,
    423px 1964px #fff,
    1945px 439px #fff,
    1377px 689px #fff,
    1120px 1437px #fff,
    1876px 668px #fff,
    907px 1324px #fff,
    343px 1976px #fff,
    1816px 1501px #fff,
    1849px 177px #fff,
    647px 91px #fff,
    1984px 1012px #fff,
    1336px 1300px #fff,
    128px 648px #fff,
    305px 1060px #fff,
    1324px 826px #fff,
    1263px 1314px #fff,
    1801px 629px #fff,
    1614px 1555px #fff,
    1634px 90px #fff,
    1603px 452px #fff,
    891px 1984px #fff,
    1556px 1906px #fff,
    121px 68px #fff,
    1676px 1714px #fff,
    516px 936px #fff,
    1947px 1492px #fff,
    1455px 1519px #fff,
    45px 602px #fff,
    205px 1039px #fff,
    793px 172px #fff,
    1562px 1739px #fff,
    1056px 110px #fff,
    1512px 379px #fff,
    1795px 1621px #fff,
    1848px 607px #fff,
    262px 1719px #fff,
    477px 991px #fff,
    483px 883px #fff,
    1239px 1197px #fff,
    1496px 647px #fff,
    1649px 25px #fff,
    1491px 1946px #fff,
    119px 996px #fff,
    179px 1472px #fff,
    1341px 808px #fff,
    1565px 1700px #fff,
    407px 1544px #fff,
    1754px 357px #fff,
    1288px 981px #fff,
    902px 1997px #fff,
    1755px 1668px #fff,
    186px 877px #fff,
    1202px 1882px #fff,
    461px 1213px #fff,
    1400px 748px #fff,
    1969px 1899px #fff,
    809px 522px #fff,
    514px 1219px #fff,
    374px 275px #fff,
    938px 1973px #fff,
    357px 552px #fff,
    144px 1722px #fff,
    1572px 912px #fff,
    402px 1858px #fff,
    1544px 1195px #fff,
    667px 1257px #fff,
    727px 1496px #fff,
    993px 232px #fff,
    1772px 313px #fff,
    1040px 1590px #fff,
    1204px 1973px #fff,
    1268px 79px #fff,
    1555px 1048px #fff,
    986px 1707px #fff,
    978px 1710px #fff,
    713px 360px #fff,
    407px 863px #fff,
    461px 736px #fff,
    284px 1608px #fff,
    103px 430px #fff,
    1283px 1319px #fff,
    977px 1186px #fff,
    1966px 1516px #fff,
    1287px 1129px #fff,
    70px 1098px #fff,
    1189px 889px #fff,
    1126px 1734px #fff,
    309px 1292px #fff,
    879px 764px #fff,
    65px 473px #fff,
    1003px 1959px #fff,
    658px 791px #fff,
    402px 1576px #fff,
    35px 622px #fff,
    529px 1589px #fff,
    164px 666px #fff,
    1876px 1290px #fff,
    1541px 526px #fff,
    270px 1297px #fff,
    440px 865px #fff,
    1500px 802px #fff,
    182px 1754px #fff,
    1264px 892px #fff,
    272px 1249px #fff,
    1289px 1535px #fff,
    190px 1646px #fff,
    955px 242px #fff,
    1456px 1597px #fff,
    1727px 1983px #fff,
    635px 801px #fff,
    226px 455px #fff,
    1396px 1710px #fff,
    849px 1863px #fff,
    237px 1264px #fff,
    839px 140px #fff,
    1122px 735px #fff,
    1280px 15px #fff,
    1318px 242px #fff,
    1819px 1148px #fff,
    333px 1392px #fff,
    1949px 553px #fff,
    1878px 1332px #fff,
    467px 548px #fff,
    1812px 1082px #fff,
    1067px 193px #fff,
    243px 156px #fff,
    483px 1616px #fff,
    1714px 933px #fff,
    759px 1800px #fff,
    1822px 995px #fff,
    1877px 572px #fff,
    581px 1084px #fff,
    107px 732px #fff,
    642px 1837px #fff,
    166px 1493px #fff,
    1555px 198px #fff,
    819px 307px #fff,
    947px 345px #fff,
    827px 224px #fff,
    927px 1394px #fff,
    540px 467px #fff,
    1093px 405px #fff,
    1140px 927px #fff,
    130px 529px #fff,
    33px 1980px #fff,
    1147px 1663px #fff,
    1616px 1436px #fff,
    528px 710px #fff,
    798px 1100px #fff,
    505px 1480px #fff,
    899px 641px #fff,
    1909px 1949px #fff,
    1311px 964px #fff,
    979px 1301px #fff,
    1393px 969px #fff,
    1793px 1886px #fff,
    292px 357px #fff,
    1196px 1718px #fff,
    1290px 1994px #fff,
    537px 1973px #fff,
    1181px 1674px #fff,
    1740px 1566px #fff,
    1307px 265px #fff,
    922px 522px #fff,
    1892px 472px #fff,
    384px 1746px #fff,
    392px 1098px #fff,
    647px 548px #fff,
    390px 1498px #fff,
    1246px 138px #fff,
    730px 876px #fff,
    192px 1472px #fff,
    1790px 1789px #fff,
    928px 311px #fff,
    1253px 1647px #fff,
    747px 1921px #fff,
    1561px 1025px #fff,
    1533px 1292px #fff,
    1985px 195px #fff,
    728px 729px #fff,
    1712px 1936px #fff,
    512px 1717px #fff,
    1528px 483px #fff,
    313px 1642px #fff,
    281px 1849px #fff,
    1212px 799px #fff,
    435px 1191px #fff,
    1422px 611px #fff,
    1718px 1964px #fff,
    411px 944px #fff,
    210px 636px #fff,
    1502px 1295px #fff,
    1434px 349px #fff,
    769px 60px #fff,
    747px 1053px #fff,
    789px 504px #fff,
    1436px 1264px #fff,
    1893px 1225px #fff,
    1394px 1788px #fff,
    1108px 1317px #fff,
    1673px 1395px #fff,
    854px 1010px #fff,
    1705px 80px #fff,
    1858px 148px #fff,
    1729px 344px #fff,
    1388px 664px #fff,
    895px 406px #fff,
    1479px 157px #fff,
    1441px 1157px #fff,
    552px 1900px #fff,
    516px 364px #fff,
    1647px 189px #fff,
    1427px 1071px #fff,
    785px 729px #fff,
    1080px 1710px #fff,
    504px 204px #fff,
    1177px 1622px #fff,
    657px 34px #fff,
    1296px 1099px #fff,
    248px 180px #fff,
    1212px 1568px #fff,
    667px 1562px #fff,
    695px 841px #fff,
    1608px 1247px #fff,
    751px 882px #fff,
    87px 167px #fff,
    607px 1368px #fff,
    1363px 1203px #fff,
    1836px 317px #fff,
    1668px 1703px #fff,
    830px 1154px #fff,
    1721px 1398px #fff,
    1601px 1280px #fff,
    976px 874px #fff,
    1743px 254px #fff,
    1020px 1815px #fff,
    1670px 1766px #fff,
    1890px 735px #fff,
    1379px 136px #fff,
    1864px 695px #fff,
    206px 965px #fff,
    1404px 1932px #fff,
    1923px 1360px #fff,
    247px 682px #fff,
    519px 1708px #fff,
    645px 750px #fff,
    1164px 1204px #fff,
    834px 323px #fff,
    172px 1350px #fff,
    213px 972px #fff,
    1837px 190px #fff,
    285px 1806px #fff,
    1047px 1299px #fff,
    1548px 825px #fff,
    1730px 324px #fff,
    1346px 1909px #fff,
    772px 270px #fff,
    345px 1190px #fff,
    478px 1433px #fff,
    1479px 25px #fff,
    1994px 1830px #fff,
    1744px 732px #fff,
    20px 1635px #fff,
    690px 1795px #fff,
    1594px 569px #fff,
    579px 245px #fff,
    1398px 733px #fff,
    408px 1352px #fff,
    1774px 120px #fff,
    1152px 1370px #fff,
    1698px 1810px #fff,
    710px 1450px #fff,
    665px 286px #fff,
    493px 1720px #fff,
    786px 5px #fff,
    637px 1140px #fff,
    764px 324px #fff,
    927px 310px #fff,
    938px 1424px #fff,
    1884px 744px #fff,
    913px 462px #fff,
    1831px 1936px #fff,
    1527px 249px #fff,
    36px 1381px #fff,
    1597px 581px #fff,
    1530px 355px #fff,
    949px 459px #fff,
    799px 828px #fff,
    242px 1471px #fff,
    654px 797px #fff,
    796px 594px #fff,
    1365px 678px #fff,
    752px 23px #fff,
    1630px 541px #fff,
    982px 72px #fff,
    1733px 1831px #fff,
    21px 412px #fff,
    775px 998px #fff,
    335px 1945px #fff,
    264px 583px #fff,
    158px 1311px #fff,
    528px 164px #fff,
    1978px 574px #fff,
    717px 1203px #fff,
    734px 1591px #fff,
    1555px 820px #fff,
    16px 1943px #fff,
    1625px 1177px #fff,
    1236px 690px #fff,
    1585px 1590px #fff,
    1737px 1728px #fff,
    721px 698px #fff,
    1804px 1186px #fff,
    166px 980px #fff,
    1850px 230px #fff,
    330px 1712px #fff,
    95px 797px #fff,
    1948px 1078px #fff,
    469px 939px #fff,
    1269px 1899px #fff,
    955px 1220px #fff,
    1137px 1075px #fff,
    312px 1293px #fff,
    986px 1762px #fff,
    1103px 1238px #fff,
    428px 1993px #fff,
    355px 570px #fff,
    977px 1836px #fff,
    1395px 1092px #fff,
    276px 913px #fff,
    1743px 656px #fff,
    773px 502px #fff,
    1686px 1322px #fff,
    1516px 1945px #fff,
    1334px 501px #fff,
    266px 156px #fff,
    455px 655px #fff,
    798px 72px #fff,
    1059px 1259px #fff,
    1402px 1687px #fff,
    236px 1329px #fff,
    1455px 786px #fff,
    146px 1228px #fff,
    1851px 823px #fff,
    1062px 100px #fff,
    1220px 953px #fff,
    20px 1826px #fff,
    36px 1063px #fff,
    1525px 338px #fff,
    790px 1521px #fff,
    741px 1099px #fff,
    288px 1489px #fff,
    700px 1060px #fff,
    390px 1071px #fff,
    411px 1036px #fff,
    1853px 1072px #fff,
    1446px 1085px #fff,
    1164px 874px #fff,
    924px 925px #fff,
    291px 271px #fff,
    1257px 1964px #fff,
    1580px 1352px #fff,
    1507px 1216px #fff,
    211px 956px #fff,
    985px 1195px #fff,
    975px 1640px #fff,
    518px 101px #fff,
    663px 1395px #fff,
    914px 532px #fff,
    145px 1320px #fff,
    69px 1397px #fff,
    982px 523px #fff,
    257px 725px #fff,
    1599px 831px #fff,
    1636px 1513px #fff,
    1250px 1158px #fff,
    1132px 604px #fff,
    183px 102px #fff,
    1057px 318px #fff,
    1247px 1835px #fff,
    1983px 1110px #fff,
    1077px 1455px #fff,
    921px 1770px #fff,
    806px 1350px #fff,
    1938px 1992px #fff,
    855px 1260px #fff,
    902px 1345px #fff,
    658px 1908px #fff,
    1845px 679px #fff,
    712px 1482px #fff,
    595px 950px #fff,
    1784px 1992px #fff,
    1847px 1785px #fff,
    691px 1004px #fff,
    175px 1179px #fff,
    1666px 1911px #fff,
    41px 61px #fff,
    971px 1080px #fff,
    1830px 1450px #fff,
    1351px 1518px #fff,
    1257px 99px #fff,
    1395px 1498px #fff,
    1117px 252px #fff,
    1779px 597px #fff,
    1346px 729px #fff,
    1108px 1144px #fff,
    402px 691px #fff,
    72px 496px #fff,
    1673px 1604px #fff,
    1497px 974px #fff,
    1865px 1664px #fff,
    88px 806px #fff,
    918px 77px #fff,
    244px 1118px #fff,
    256px 1820px #fff,
    1851px 1840px #fff,
    605px 1851px #fff,
    634px 383px #fff,
    865px 37px #fff,
    943px 1024px #fff,
    1951px 177px #fff,
    1097px 523px #fff,
    985px 1700px #fff,
    1243px 122px #fff,
    768px 1070px #fff,
    468px 194px #fff,
    320px 1867px #fff,
    1850px 185px #fff,
    380px 1616px #fff,
    468px 1294px #fff,
    1122px 1743px #fff,
    884px 299px #fff,
    1300px 1917px #fff,
    1860px 396px #fff,
    1270px 990px #fff,
    529px 733px #fff,
    1975px 1347px #fff,
    1885px 685px #fff,
    226px 506px #fff,
    651px 878px #fff,
    1323px 680px #fff,
    1284px 680px #fff,
    238px 1967px #fff,
    911px 174px #fff,
    1111px 521px #fff,
    1150px 85px #fff,
    794px 502px #fff,
    484px 1856px #fff,
    1809px 368px #fff,
    112px 953px #fff,
    590px 1009px #fff,
    1655px 311px #fff,
    100px 1026px #fff,
    1803px 352px #fff,
    865px 306px #fff,
    1077px 1019px #fff,
    1335px 872px #fff,
    1647px 1298px #fff,
    1233px 1387px #fff,
    698px 1036px #fff,
    659px 1860px #fff,
    388px 1412px #fff,
    1212px 458px #fff,
    755px 1468px #fff,
    696px 1654px #fff,
    1144px 60px #fff;
}

#stars2 {
  width: 2px;
  height: 2px;
  z-index: -100;
  background: transparent;
  animation: animStar 100s linear infinite;
  box-shadow:
    1448px 320px #fff,
    1775px 1663px #fff,
    332px 1364px #fff,
    878px 340px #fff,
    569px 1832px #fff,
    1422px 1684px #fff,
    1946px 1907px #fff,
    121px 979px #fff,
    1044px 1069px #fff,
    463px 381px #fff,
    423px 112px #fff,
    523px 1179px #fff,
    779px 654px #fff,
    1398px 694px #fff,
    1085px 1464px #fff,
    1599px 1869px #fff,
    801px 1882px #fff,
    779px 1231px #fff,
    552px 932px #fff,
    1057px 1196px #fff,
    282px 1280px #fff,
    496px 1986px #fff,
    1833px 1120px #fff,
    1802px 1293px #fff,
    6px 1696px #fff,
    412px 1902px #fff,
    605px 438px #fff,
    24px 1212px #fff,
    234px 1320px #fff,
    544px 344px #fff,
    1107px 170px #fff,
    1603px 196px #fff,
    905px 648px #fff,
    68px 1458px #fff,
    649px 1969px #fff,
    744px 675px #fff,
    1127px 478px #fff,
    714px 1814px #fff,
    1486px 526px #fff,
    270px 1636px #fff,
    1931px 149px #fff,
    1807px 378px #fff,
    8px 390px #fff,
    1415px 699px #fff,
    1473px 1211px #fff,
    1590px 141px #fff,
    270px 1705px #fff,
    69px 1423px #fff,
    1108px 1053px #fff,
    1946px 128px #fff,
    371px 371px #fff,
    1490px 220px #fff,
    357px 1885px #fff,
    363px 363px #fff,
    1896px 1256px #fff,
    1979px 1050px #fff,
    947px 1342px #fff,
    1754px 242px #fff,
    514px 974px #fff,
    65px 1477px #fff,
    1840px 547px #fff,
    950px 695px #fff,
    459px 1150px #fff,
    1124px 1502px #fff,
    481px 940px #fff,
    680px 839px #fff,
    797px 1169px #fff,
    1977px 1491px #fff,
    734px 1724px #fff,
    210px 298px #fff,
    816px 628px #fff,
    686px 770px #fff,
    1721px 267px #fff,
    1663px 511px #fff,
    1481px 1141px #fff,
    582px 248px #fff,
    1308px 953px #fff,
    628px 657px #fff,
    897px 1535px #fff,
    270px 931px #fff,
    791px 467px #fff,
    1336px 1732px #fff,
    1013px 1653px #fff,
    1911px 956px #fff,
    587px 816px #fff,
    83px 456px #fff,
    930px 1478px #fff,
    1587px 1694px #fff,
    614px 1200px #fff,
    302px 1782px #fff,
    1711px 1432px #fff,
    443px 904px #fff,
    1666px 714px #fff,
    1588px 1167px #fff,
    273px 1075px #fff,
    1679px 461px #fff,
    721px 664px #fff,
    1202px 10px #fff,
    166px 1126px #fff,
    331px 1628px #fff,
    430px 1565px #fff,
    1585px 509px #fff,
    640px 38px #fff,
    822px 837px #fff,
    1760px 1664px #fff,
    1122px 1458px #fff,
    398px 131px #fff,
    689px 285px #fff,
    460px 652px #fff,
    1627px 365px #fff,
    348px 1648px #fff,
    819px 1946px #fff,
    981px 1917px #fff,
    323px 76px #fff,
    979px 684px #fff,
    887px 536px #fff,
    1348px 1596px #fff,
    1055px 666px #fff,
    1402px 1797px #fff,
    1300px 1055px #fff,
    937px 238px #fff,
    1474px 1815px #fff,
    1144px 1710px #fff,
    1629px 1087px #fff,
    911px 919px #fff,
    771px 819px #fff,
    403px 720px #fff,
    163px 736px #fff,
    1062px 238px #fff,
    1774px 818px #fff,
    1874px 1178px #fff,
    1177px 699px #fff,
    1244px 1244px #fff,
    1371px 58px #fff,
    564px 1515px #fff,
    1824px 487px #fff,
    929px 702px #fff,
    394px 1348px #fff,
    1161px 641px #fff,
    219px 1841px #fff,
    358px 941px #fff,
    140px 1759px #fff,
    1019px 1345px #fff,
    274px 436px #fff,
    1433px 1605px #fff,
    1798px 1426px #fff,
    294px 1848px #fff,
    1681px 1877px #fff,
    1344px 1824px #fff,
    1439px 1632px #fff,
    161px 1012px #fff,
    1308px 588px #fff,
    1789px 582px #fff,
    721px 1910px #fff,
    318px 218px #fff,
    607px 319px #fff,
    495px 535px #fff,
    1552px 1575px #fff,
    1562px 67px #fff,
    403px 926px #fff,
    1096px 1800px #fff,
    1814px 1709px #fff,
    1882px 1831px #fff,
    533px 46px #fff,
    823px 969px #fff,
    530px 165px #fff,
    1030px 352px #fff,
    1681px 313px #fff,
    338px 115px #fff,
    1607px 211px #fff,
    1718px 1184px #fff,
    1589px 659px #fff,
    278px 355px #fff,
    464px 1464px #fff,
    1165px 277px #fff,
    950px 694px #fff,
    1746px 293px #fff,
    793px 911px #fff,
    528px 773px #fff,
    1883px 1694px #fff,
    748px 182px #fff,
    1924px 1531px #fff,
    100px 636px #fff,
    1473px 1445px #fff,
    1264px 1244px #fff,
    850px 1377px #fff,
    987px 1976px #fff,
    933px 1761px #fff,
    922px 1270px #fff,
    500px 396px #fff,
    1324px 8px #fff,
    1967px 1814px #fff,
    1072px 1401px #fff,
    961px 37px #fff,
    156px 81px #fff,
    1915px 502px #fff,
    1076px 1846px #fff,
    152px 1669px #fff,
    986px 1529px #fff,
    1667px 1137px #fff;
}

#stars2:after {
  content: "";
  position: absolute;
  top: 2000px;
  width: 2px;
  height: 2px;
  background: transparent;
  box-shadow:
    1448px 320px #fff,
    1775px 1663px #fff,
    332px 1364px #fff,
    878px 340px #fff,
    569px 1832px #fff,
    1422px 1684px #fff,
    1946px 1907px #fff,
    121px 979px #fff,
    1044px 1069px #fff,
    463px 381px #fff,
    423px 112px #fff,
    523px 1179px #fff,
    779px 654px #fff,
    1398px 694px #fff,
    1085px 1464px #fff,
    1599px 1869px #fff,
    801px 1882px #fff,
    779px 1231px #fff,
    552px 932px #fff,
    1057px 1196px #fff,
    282px 1280px #fff,
    496px 1986px #fff,
    1833px 1120px #fff,
    1802px 1293px #fff,
    6px 1696px #fff,
    412px 1902px #fff,
    605px 438px #fff,
    24px 1212px #fff,
    234px 1320px #fff,
    544px 344px #fff,
    1107px 170px #fff,
    1603px 196px #fff,
    905px 648px #fff,
    68px 1458px #fff,
    649px 1969px #fff,
    744px 675px #fff,
    1127px 478px #fff,
    714px 1814px #fff,
    1486px 526px #fff,
    270px 1636px #fff,
    1931px 149px #fff,
    1807px 378px #fff,
    8px 390px #fff,
    1415px 699px #fff,
    1473px 1211px #fff,
    1590px 141px #fff,
    270px 1705px #fff,
    69px 1423px #fff,
    1108px 1053px #fff,
    1946px 128px #fff,
    371px 371px #fff,
    1490px 220px #fff,
    357px 1885px #fff,
    363px 363px #fff,
    1896px 1256px #fff,
    1979px 1050px #fff,
    947px 1342px #fff,
    1754px 242px #fff,
    514px 974px #fff,
    65px 1477px #fff,
    1840px 547px #fff,
    950px 695px #fff,
    459px 1150px #fff,
    1124px 1502px #fff,
    481px 940px #fff,
    680px 839px #fff,
    797px 1169px #fff,
    1977px 1491px #fff,
    734px 1724px #fff,
    210px 298px #fff,
    816px 628px #fff,
    686px 770px #fff,
    1721px 267px #fff,
    1663px 511px #fff,
    1481px 1141px #fff,
    582px 248px #fff,
    1308px 953px #fff,
    628px 657px #fff,
    897px 1535px #fff,
    270px 931px #fff,
    791px 467px #fff,
    1336px 1732px #fff,
    1013px 1653px #fff,
    1911px 956px #fff,
    587px 816px #fff,
    83px 456px #fff,
    930px 1478px #fff,
    1587px 1694px #fff,
    614px 1200px #fff,
    302px 1782px #fff,
    1711px 1432px #fff,
    443px 904px #fff,
    1666px 714px #fff,
    1588px 1167px #fff,
    273px 1075px #fff,
    1679px 461px #fff,
    721px 664px #fff,
    1202px 10px #fff,
    166px 1126px #fff,
    331px 1628px #fff,
    430px 1565px #fff,
    1585px 509px #fff,
    640px 38px #fff,
    822px 837px #fff,
    1760px 1664px #fff,
    1122px 1458px #fff,
    398px 131px #fff,
    689px 285px #fff,
    460px 652px #fff,
    1627px 365px #fff,
    348px 1648px #fff,
    819px 1946px #fff,
    981px 1917px #fff,
    323px 76px #fff,
    979px 684px #fff,
    887px 536px #fff,
    1348px 1596px #fff,
    1055px 666px #fff,
    1402px 1797px #fff,
    1300px 1055px #fff,
    937px 238px #fff,
    1474px 1815px #fff,
    1144px 1710px #fff,
    1629px 1087px #fff,
    911px 919px #fff,
    771px 819px #fff,
    403px 720px #fff,
    163px 736px #fff,
    1062px 238px #fff,
    1774px 818px #fff,
    1874px 1178px #fff,
    1177px 699px #fff,
    1244px 1244px #fff,
    1371px 58px #fff,
    564px 1515px #fff,
    1824px 487px #fff,
    929px 702px #fff,
    394px 1348px #fff,
    1161px 641px #fff,
    219px 1841px #fff,
    358px 941px #fff,
    140px 1759px #fff,
    1019px 1345px #fff,
    274px 436px #fff,
    1433px 1605px #fff,
    1798px 1426px #fff,
    294px 1848px #fff,
    1681px 1877px #fff,
    1344px 1824px #fff,
    1439px 1632px #fff,
    161px 1012px #fff,
    1308px 588px #fff,
    1789px 582px #fff,
    721px 1910px #fff,
    318px 218px #fff,
    607px 319px #fff,
    495px 535px #fff,
    1552px 1575px #fff,
    1562px 67px #fff,
    403px 926px #fff,
    1096px 1800px #fff,
    1814px 1709px #fff,
    1882px 1831px #fff,
    533px 46px #fff,
    823px 969px #fff,
    530px 165px #fff,
    1030px 352px #fff,
    1681px 313px #fff,
    338px 115px #fff,
    1607px 211px #fff,
    1718px 1184px #fff,
    1589px 659px #fff,
    278px 355px #fff,
    464px 1464px #fff,
    1165px 277px #fff,
    950px 694px #fff,
    1746px 293px #fff,
    793px 911px #fff,
    528px 773px #fff,
    1883px 1694px #fff,
    748px 182px #fff,
    1924px 1531px #fff,
    100px 636px #fff,
    1473px 1445px #fff,
    1264px 1244px #fff,
    850px 1377px #fff,
    987px 1976px #fff,
    933px 1761px #fff,
    922px 1270px #fff,
    500px 396px #fff,
    1324px 8px #fff,
    1967px 1814px #fff,
    1072px 1401px #fff,
    961px 37px #fff,
    156px 81px #fff,
    1915px 502px #fff,
    1076px 1846px #fff,
    152px 1669px #fff,
    986px 1529px #fff,
    1667px 1137px #fff;
}

#stars3 {
  width: 3px;
  height: 3px;
  z-index: -100;
  background: transparent;
  animation: animStar 150s linear infinte;
  box-shadow:
    387px 1878px #fff,
    760px 1564px #fff,
    1487px 999px #fff,
    948px 1828px #fff,
    1977px 1001px #fff,
    1284px 1963px #fff,
    656px 284px #fff,
    1268px 1635px #fff,
    1820px 598px #fff,
    642px 1900px #fff,
    296px 57px #fff,
    921px 1620px #fff,
    476px 1858px #fff,
    658px 613px #fff,
    1171px 1363px #fff,
    1419px 283px #fff,
    1037px 731px #fff,
    503px 663px #fff,
    1562px 463px #fff,
    383px 1197px #fff,
    1171px 1233px #fff,
    876px 1768px #fff,
    856px 1615px #fff,
    1375px 1924px #fff,
    1725px 918px #fff,
    952px 119px #fff,
    768px 1212px #fff,
    992px 1462px #fff,
    1929px 717px #fff,
    1947px 755px #fff,
    1818px 1123px #fff,
    1896px 1672px #fff,
    460px 198px #fff,
    256px 271px #fff,
    752px 544px #fff,
    1222px 1859px #fff,
    1851px 443px #fff,
    313px 1858px #fff,
    709px 446px #fff,
    1546px 697px #fff,
    674px 1155px #fff,
    1112px 130px #fff,
    355px 1790px #fff,
    1496px 974px #fff,
    1696px 480px #fff,
    1316px 1265px #fff,
    1645px 1063px #fff,
    1182px 237px #fff,
    427px 1582px #fff,
    859px 253px #fff,
    458px 939px #fff,
    1517px 1644px #fff,
    1943px 60px #fff,
    212px 1650px #fff,
    966px 1786px #fff,
    473px 712px #fff,
    130px 76px #fff,
    1417px 1186px #fff,
    909px 1580px #fff,
    1913px 762px #fff,
    204px 1143px #fff,
    1998px 1057px #fff,
    1468px 1301px #fff,
    144px 1676px #fff,
    21px 1601px #fff,
    382px 1362px #fff,
    912px 753px #fff,
    1488px 1405px #fff,
    802px 156px #fff,
    174px 550px #fff,
    338px 1366px #fff,
    1197px 774px #fff,
    602px 486px #fff,
    682px 1877px #fff,
    348px 1503px #fff,
    407px 1139px #fff,
    950px 1400px #fff,
    922px 1139px #fff,
    1697px 293px #fff,
    1238px 1281px #fff,
    1038px 1197px #fff,
    376px 1889px #fff,
    1255px 1680px #fff,
    1008px 1316px #fff,
    1538px 1447px #fff,
    1186px 874px #fff,
    1967px 640px #fff,
    1341px 19px #fff,
    29px 1732px #fff,
    16px 1650px #fff,
    1021px 1075px #fff,
    723px 424px #fff,
    1175px 41px #fff,
    494px 1957px #fff,
    1296px 431px #fff,
    175px 1507px #fff,
    831px 121px #fff,
    498px 1947px #fff,
    617px 880px #fff,
    240px 403px #fff;
}

#stars3:after {
  content: "";
  position: absolute;
  top: 2000px;
  width: 3px;
  height: 3px;
  background: transparent;
  box-shadow:
    387px 1878px #fff,
    760px 1564px #fff,
    1487px 999px #fff,
    948px 1828px #fff,
    1977px 1001px #fff,
    1284px 1963px #fff,
    656px 284px #fff,
    1268px 1635px #fff,
    1820px 598px #fff,
    642px 1900px #fff,
    296px 57px #fff,
    921px 1620px #fff,
    476px 1858px #fff,
    658px 613px #fff,
    1171px 1363px #fff,
    1419px 283px #fff,
    1037px 731px #fff,
    503px 663px #fff,
    1562px 463px #fff,
    383px 1197px #fff,
    1171px 1233px #fff,
    876px 1768px #fff,
    856px 1615px #fff,
    1375px 1924px #fff,
    1725px 918px #fff,
    952px 119px #fff,
    768px 1212px #fff,
    992px 1462px #fff,
    1929px 717px #fff,
    1947px 755px #fff,
    1818px 1123px #fff,
    1896px 1672px #fff,
    460px 198px #fff,
    256px 271px #fff,
    752px 544px #fff,
    1222px 1859px #fff,
    1851px 443px #fff,
    313px 1858px #fff,
    709px 446px #fff,
    1546px 697px #fff,
    674px 1155px #fff,
    1112px 130px #fff,
    355px 1790px #fff,
    1496px 974px #fff,
    1696px 480px #fff,
    1316px 1265px #fff,
    1645px 1063px #fff,
    1182px 237px #fff,
    427px 1582px #fff,
    859px 253px #fff,
    458px 939px #fff,
    1517px 1644px #fff,
    1943px 60px #fff,
    212px 1650px #fff,
    966px 1786px #fff,
    473px 712px #fff,
    130px 76px #fff,
    1417px 1186px #fff,
    909px 1580px #fff,
    1913px 762px #fff,
    204px 1143px #fff,
    1998px 1057px #fff,
    1468px 1301px #fff,
    144px 1676px #fff,
    21px 1601px #fff,
    382px 1362px #fff,
    912px 753px #fff,
    1488px 1405px #fff,
    802px 156px #fff,
    174px 550px #fff,
    338px 1366px #fff,
    1197px 774px #fff,
    602px 486px #fff,
    682px 1877px #fff,
    348px 1503px #fff,
    407px 1139px #fff,
    950px 1400px #fff,
    922px 1139px #fff,
    1697px 293px #fff,
    1238px 1281px #fff,
    1038px 1197px #fff,
    376px 1889px #fff,
    1255px 1680px #fff,
    1008px 1316px #fff,
    1538px 1447px #fff,
    1186px 874px #fff,
    1967px 640px #fff,
    1341px 19px #fff,
    29px 1732px #fff,
    16px 1650px #fff,
    1021px 1075px #fff,
    723px 424px #fff,
    1175px 41px #fff,
    494px 1957px #fff,
    1296px 431px #fff,
    175px 1507px #fff,
    831px 121px #fff,
    498px 1947px #fff,
    617px 880px #fff,
    240px 403px #fff;
}

@keyframes animStar {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-2000px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/stars.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,uCAAuC;EACvC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;oBA4rBkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;oBA4rBkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,wCAAwC;EACxC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;sBAwMoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;sBAwMoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,uCAAuC;EACvC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;oBAoGkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;oBAoGkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;EAChC;AACF","sourcesContent":["#stars {\n  width: 1px;\n  height: 1px;\n  background: transparent;\n  z-index: -100;\n  animation: animStar 50s linear infinite;\n  box-shadow:\n    779px 1331px #fff,\n    324px 42px #fff,\n    303px 586px #fff,\n    1312px 276px #fff,\n    451px 625px #fff,\n    521px 1931px #fff,\n    1087px 1871px #fff,\n    36px 1546px #fff,\n    132px 934px #fff,\n    1698px 901px #fff,\n    1418px 664px #fff,\n    1448px 1157px #fff,\n    1084px 232px #fff,\n    347px 1776px #fff,\n    1722px 243px #fff,\n    1629px 835px #fff,\n    479px 969px #fff,\n    1231px 960px #fff,\n    586px 384px #fff,\n    164px 527px #fff,\n    8px 646px #fff,\n    1150px 1126px #fff,\n    665px 1357px #fff,\n    1556px 1982px #fff,\n    1260px 1961px #fff,\n    1675px 1741px #fff,\n    1843px 1514px #fff,\n    718px 1628px #fff,\n    242px 1343px #fff,\n    1497px 1880px #fff,\n    1364px 230px #fff,\n    1739px 1302px #fff,\n    636px 959px #fff,\n    304px 686px #fff,\n    614px 751px #fff,\n    1935px 816px #fff,\n    1428px 60px #fff,\n    355px 335px #fff,\n    1594px 158px #fff,\n    90px 60px #fff,\n    1553px 162px #fff,\n    1239px 1825px #fff,\n    1945px 587px #fff,\n    749px 1785px #fff,\n    1987px 1172px #fff,\n    1301px 1237px #fff,\n    1039px 342px #fff,\n    1585px 1481px #fff,\n    995px 1048px #fff,\n    524px 932px #fff,\n    214px 413px #fff,\n    1701px 1300px #fff,\n    1037px 1613px #fff,\n    1871px 996px #fff,\n    1360px 1635px #fff,\n    1110px 1313px #fff,\n    412px 1783px #fff,\n    1949px 177px #fff,\n    903px 1854px #fff,\n    700px 1936px #fff,\n    378px 125px #fff,\n    308px 834px #fff,\n    1118px 962px #fff,\n    1350px 1929px #fff,\n    781px 1811px #fff,\n    561px 137px #fff,\n    757px 1148px #fff,\n    1670px 1979px #fff,\n    343px 739px #fff,\n    945px 795px #fff,\n    576px 1903px #fff,\n    1078px 1436px #fff,\n    1583px 450px #fff,\n    1366px 474px #fff,\n    297px 1873px #fff,\n    192px 162px #fff,\n    1624px 1633px #fff,\n    59px 453px #fff,\n    82px 1872px #fff,\n    1933px 498px #fff,\n    1966px 1974px #fff,\n    1975px 1688px #fff,\n    779px 314px #fff,\n    1858px 1543px #fff,\n    73px 1507px #fff,\n    1693px 975px #fff,\n    1683px 108px #fff,\n    1768px 1654px #fff,\n    654px 14px #fff,\n    494px 171px #fff,\n    1689px 1895px #fff,\n    1660px 263px #fff,\n    1031px 903px #fff,\n    1203px 1393px #fff,\n    1333px 1421px #fff,\n    1113px 41px #fff,\n    1206px 1645px #fff,\n    1325px 1635px #fff,\n    142px 388px #fff,\n    572px 215px #fff,\n    1535px 296px #fff,\n    1419px 407px #fff,\n    1379px 1003px #fff,\n    329px 469px #fff,\n    1791px 1652px #fff,\n    935px 1802px #fff,\n    1330px 1820px #fff,\n    421px 1933px #fff,\n    828px 365px #fff,\n    275px 316px #fff,\n    707px 960px #fff,\n    1605px 1554px #fff,\n    625px 58px #fff,\n    717px 1697px #fff,\n    1669px 246px #fff,\n    1925px 322px #fff,\n    1154px 1803px #fff,\n    1929px 295px #fff,\n    1248px 240px #fff,\n    1045px 1755px #fff,\n    166px 942px #fff,\n    1888px 1773px #fff,\n    678px 1963px #fff,\n    1370px 569px #fff,\n    1974px 1400px #fff,\n    1786px 460px #fff,\n    51px 307px #fff,\n    784px 1400px #fff,\n    730px 1258px #fff,\n    1712px 393px #fff,\n    416px 170px #fff,\n    1797px 1932px #fff,\n    572px 219px #fff,\n    1557px 1856px #fff,\n    218px 8px #fff,\n    348px 1334px #fff,\n    469px 413px #fff,\n    385px 1738px #fff,\n    1357px 1818px #fff,\n    240px 942px #fff,\n    248px 1847px #fff,\n    1535px 806px #fff,\n    236px 1514px #fff,\n    1429px 1556px #fff,\n    73px 1633px #fff,\n    1398px 1121px #fff,\n    671px 1301px #fff,\n    1404px 1663px #fff,\n    740px 1018px #fff,\n    1600px 377px #fff,\n    785px 514px #fff,\n    112px 1084px #fff,\n    1915px 1887px #fff,\n    1463px 1848px #fff,\n    687px 1115px #fff,\n    1268px 1768px #fff,\n    1729px 1425px #fff,\n    1284px 1022px #fff,\n    801px 974px #fff,\n    1975px 1317px #fff,\n    1354px 834px #fff,\n    1446px 1484px #fff,\n    1283px 1786px #fff,\n    11px 523px #fff,\n    1842px 236px #fff,\n    1355px 654px #fff,\n    429px 7px #fff,\n    1033px 1128px #fff,\n    157px 297px #fff,\n    545px 635px #fff,\n    52px 1080px #fff,\n    827px 1520px #fff,\n    1121px 490px #fff,\n    9px 309px #fff,\n    1744px 1586px #fff,\n    1014px 417px #fff,\n    1534px 524px #fff,\n    958px 552px #fff,\n    1403px 1496px #fff,\n    387px 703px #fff,\n    1522px 548px #fff,\n    1355px 282px #fff,\n    1532px 601px #fff,\n    1838px 790px #fff,\n    290px 259px #fff,\n    295px 598px #fff,\n    1601px 539px #fff,\n    1561px 1272px #fff,\n    34px 1922px #fff,\n    1024px 543px #fff,\n    467px 369px #fff,\n    722px 333px #fff,\n    1976px 1255px #fff,\n    766px 983px #fff,\n    1582px 1285px #fff,\n    12px 512px #fff,\n    617px 1410px #fff,\n    682px 577px #fff,\n    1334px 1438px #fff,\n    439px 327px #fff,\n    1617px 1661px #fff,\n    673px 129px #fff,\n    794px 941px #fff,\n    1386px 1902px #fff,\n    37px 1353px #fff,\n    1467px 1353px #fff,\n    416px 18px #fff,\n    187px 344px #fff,\n    200px 1898px #fff,\n    1491px 1619px #fff,\n    811px 347px #fff,\n    924px 1827px #fff,\n    945px 217px #fff,\n    1735px 1228px #fff,\n    379px 1890px #fff,\n    79px 761px #fff,\n    825px 1837px #fff,\n    1980px 1558px #fff,\n    1308px 1573px #fff,\n    1488px 1726px #fff,\n    382px 1208px #fff,\n    522px 595px #fff,\n    1277px 1898px #fff,\n    354px 552px #fff,\n    161px 1784px #fff,\n    614px 251px #fff,\n    526px 1576px #fff,\n    17px 212px #fff,\n    179px 996px #fff,\n    467px 1208px #fff,\n    1944px 1838px #fff,\n    1140px 1093px #fff,\n    858px 1007px #fff,\n    200px 1064px #fff,\n    423px 1964px #fff,\n    1945px 439px #fff,\n    1377px 689px #fff,\n    1120px 1437px #fff,\n    1876px 668px #fff,\n    907px 1324px #fff,\n    343px 1976px #fff,\n    1816px 1501px #fff,\n    1849px 177px #fff,\n    647px 91px #fff,\n    1984px 1012px #fff,\n    1336px 1300px #fff,\n    128px 648px #fff,\n    305px 1060px #fff,\n    1324px 826px #fff,\n    1263px 1314px #fff,\n    1801px 629px #fff,\n    1614px 1555px #fff,\n    1634px 90px #fff,\n    1603px 452px #fff,\n    891px 1984px #fff,\n    1556px 1906px #fff,\n    121px 68px #fff,\n    1676px 1714px #fff,\n    516px 936px #fff,\n    1947px 1492px #fff,\n    1455px 1519px #fff,\n    45px 602px #fff,\n    205px 1039px #fff,\n    793px 172px #fff,\n    1562px 1739px #fff,\n    1056px 110px #fff,\n    1512px 379px #fff,\n    1795px 1621px #fff,\n    1848px 607px #fff,\n    262px 1719px #fff,\n    477px 991px #fff,\n    483px 883px #fff,\n    1239px 1197px #fff,\n    1496px 647px #fff,\n    1649px 25px #fff,\n    1491px 1946px #fff,\n    119px 996px #fff,\n    179px 1472px #fff,\n    1341px 808px #fff,\n    1565px 1700px #fff,\n    407px 1544px #fff,\n    1754px 357px #fff,\n    1288px 981px #fff,\n    902px 1997px #fff,\n    1755px 1668px #fff,\n    186px 877px #fff,\n    1202px 1882px #fff,\n    461px 1213px #fff,\n    1400px 748px #fff,\n    1969px 1899px #fff,\n    809px 522px #fff,\n    514px 1219px #fff,\n    374px 275px #fff,\n    938px 1973px #fff,\n    357px 552px #fff,\n    144px 1722px #fff,\n    1572px 912px #fff,\n    402px 1858px #fff,\n    1544px 1195px #fff,\n    667px 1257px #fff,\n    727px 1496px #fff,\n    993px 232px #fff,\n    1772px 313px #fff,\n    1040px 1590px #fff,\n    1204px 1973px #fff,\n    1268px 79px #fff,\n    1555px 1048px #fff,\n    986px 1707px #fff,\n    978px 1710px #fff,\n    713px 360px #fff,\n    407px 863px #fff,\n    461px 736px #fff,\n    284px 1608px #fff,\n    103px 430px #fff,\n    1283px 1319px #fff,\n    977px 1186px #fff,\n    1966px 1516px #fff,\n    1287px 1129px #fff,\n    70px 1098px #fff,\n    1189px 889px #fff,\n    1126px 1734px #fff,\n    309px 1292px #fff,\n    879px 764px #fff,\n    65px 473px #fff,\n    1003px 1959px #fff,\n    658px 791px #fff,\n    402px 1576px #fff,\n    35px 622px #fff,\n    529px 1589px #fff,\n    164px 666px #fff,\n    1876px 1290px #fff,\n    1541px 526px #fff,\n    270px 1297px #fff,\n    440px 865px #fff,\n    1500px 802px #fff,\n    182px 1754px #fff,\n    1264px 892px #fff,\n    272px 1249px #fff,\n    1289px 1535px #fff,\n    190px 1646px #fff,\n    955px 242px #fff,\n    1456px 1597px #fff,\n    1727px 1983px #fff,\n    635px 801px #fff,\n    226px 455px #fff,\n    1396px 1710px #fff,\n    849px 1863px #fff,\n    237px 1264px #fff,\n    839px 140px #fff,\n    1122px 735px #fff,\n    1280px 15px #fff,\n    1318px 242px #fff,\n    1819px 1148px #fff,\n    333px 1392px #fff,\n    1949px 553px #fff,\n    1878px 1332px #fff,\n    467px 548px #fff,\n    1812px 1082px #fff,\n    1067px 193px #fff,\n    243px 156px #fff,\n    483px 1616px #fff,\n    1714px 933px #fff,\n    759px 1800px #fff,\n    1822px 995px #fff,\n    1877px 572px #fff,\n    581px 1084px #fff,\n    107px 732px #fff,\n    642px 1837px #fff,\n    166px 1493px #fff,\n    1555px 198px #fff,\n    819px 307px #fff,\n    947px 345px #fff,\n    827px 224px #fff,\n    927px 1394px #fff,\n    540px 467px #fff,\n    1093px 405px #fff,\n    1140px 927px #fff,\n    130px 529px #fff,\n    33px 1980px #fff,\n    1147px 1663px #fff,\n    1616px 1436px #fff,\n    528px 710px #fff,\n    798px 1100px #fff,\n    505px 1480px #fff,\n    899px 641px #fff,\n    1909px 1949px #fff,\n    1311px 964px #fff,\n    979px 1301px #fff,\n    1393px 969px #fff,\n    1793px 1886px #fff,\n    292px 357px #fff,\n    1196px 1718px #fff,\n    1290px 1994px #fff,\n    537px 1973px #fff,\n    1181px 1674px #fff,\n    1740px 1566px #fff,\n    1307px 265px #fff,\n    922px 522px #fff,\n    1892px 472px #fff,\n    384px 1746px #fff,\n    392px 1098px #fff,\n    647px 548px #fff,\n    390px 1498px #fff,\n    1246px 138px #fff,\n    730px 876px #fff,\n    192px 1472px #fff,\n    1790px 1789px #fff,\n    928px 311px #fff,\n    1253px 1647px #fff,\n    747px 1921px #fff,\n    1561px 1025px #fff,\n    1533px 1292px #fff,\n    1985px 195px #fff,\n    728px 729px #fff,\n    1712px 1936px #fff,\n    512px 1717px #fff,\n    1528px 483px #fff,\n    313px 1642px #fff,\n    281px 1849px #fff,\n    1212px 799px #fff,\n    435px 1191px #fff,\n    1422px 611px #fff,\n    1718px 1964px #fff,\n    411px 944px #fff,\n    210px 636px #fff,\n    1502px 1295px #fff,\n    1434px 349px #fff,\n    769px 60px #fff,\n    747px 1053px #fff,\n    789px 504px #fff,\n    1436px 1264px #fff,\n    1893px 1225px #fff,\n    1394px 1788px #fff,\n    1108px 1317px #fff,\n    1673px 1395px #fff,\n    854px 1010px #fff,\n    1705px 80px #fff,\n    1858px 148px #fff,\n    1729px 344px #fff,\n    1388px 664px #fff,\n    895px 406px #fff,\n    1479px 157px #fff,\n    1441px 1157px #fff,\n    552px 1900px #fff,\n    516px 364px #fff,\n    1647px 189px #fff,\n    1427px 1071px #fff,\n    785px 729px #fff,\n    1080px 1710px #fff,\n    504px 204px #fff,\n    1177px 1622px #fff,\n    657px 34px #fff,\n    1296px 1099px #fff,\n    248px 180px #fff,\n    1212px 1568px #fff,\n    667px 1562px #fff,\n    695px 841px #fff,\n    1608px 1247px #fff,\n    751px 882px #fff,\n    87px 167px #fff,\n    607px 1368px #fff,\n    1363px 1203px #fff,\n    1836px 317px #fff,\n    1668px 1703px #fff,\n    830px 1154px #fff,\n    1721px 1398px #fff,\n    1601px 1280px #fff,\n    976px 874px #fff,\n    1743px 254px #fff,\n    1020px 1815px #fff,\n    1670px 1766px #fff,\n    1890px 735px #fff,\n    1379px 136px #fff,\n    1864px 695px #fff,\n    206px 965px #fff,\n    1404px 1932px #fff,\n    1923px 1360px #fff,\n    247px 682px #fff,\n    519px 1708px #fff,\n    645px 750px #fff,\n    1164px 1204px #fff,\n    834px 323px #fff,\n    172px 1350px #fff,\n    213px 972px #fff,\n    1837px 190px #fff,\n    285px 1806px #fff,\n    1047px 1299px #fff,\n    1548px 825px #fff,\n    1730px 324px #fff,\n    1346px 1909px #fff,\n    772px 270px #fff,\n    345px 1190px #fff,\n    478px 1433px #fff,\n    1479px 25px #fff,\n    1994px 1830px #fff,\n    1744px 732px #fff,\n    20px 1635px #fff,\n    690px 1795px #fff,\n    1594px 569px #fff,\n    579px 245px #fff,\n    1398px 733px #fff,\n    408px 1352px #fff,\n    1774px 120px #fff,\n    1152px 1370px #fff,\n    1698px 1810px #fff,\n    710px 1450px #fff,\n    665px 286px #fff,\n    493px 1720px #fff,\n    786px 5px #fff,\n    637px 1140px #fff,\n    764px 324px #fff,\n    927px 310px #fff,\n    938px 1424px #fff,\n    1884px 744px #fff,\n    913px 462px #fff,\n    1831px 1936px #fff,\n    1527px 249px #fff,\n    36px 1381px #fff,\n    1597px 581px #fff,\n    1530px 355px #fff,\n    949px 459px #fff,\n    799px 828px #fff,\n    242px 1471px #fff,\n    654px 797px #fff,\n    796px 594px #fff,\n    1365px 678px #fff,\n    752px 23px #fff,\n    1630px 541px #fff,\n    982px 72px #fff,\n    1733px 1831px #fff,\n    21px 412px #fff,\n    775px 998px #fff,\n    335px 1945px #fff,\n    264px 583px #fff,\n    158px 1311px #fff,\n    528px 164px #fff,\n    1978px 574px #fff,\n    717px 1203px #fff,\n    734px 1591px #fff,\n    1555px 820px #fff,\n    16px 1943px #fff,\n    1625px 1177px #fff,\n    1236px 690px #fff,\n    1585px 1590px #fff,\n    1737px 1728px #fff,\n    721px 698px #fff,\n    1804px 1186px #fff,\n    166px 980px #fff,\n    1850px 230px #fff,\n    330px 1712px #fff,\n    95px 797px #fff,\n    1948px 1078px #fff,\n    469px 939px #fff,\n    1269px 1899px #fff,\n    955px 1220px #fff,\n    1137px 1075px #fff,\n    312px 1293px #fff,\n    986px 1762px #fff,\n    1103px 1238px #fff,\n    428px 1993px #fff,\n    355px 570px #fff,\n    977px 1836px #fff,\n    1395px 1092px #fff,\n    276px 913px #fff,\n    1743px 656px #fff,\n    773px 502px #fff,\n    1686px 1322px #fff,\n    1516px 1945px #fff,\n    1334px 501px #fff,\n    266px 156px #fff,\n    455px 655px #fff,\n    798px 72px #fff,\n    1059px 1259px #fff,\n    1402px 1687px #fff,\n    236px 1329px #fff,\n    1455px 786px #fff,\n    146px 1228px #fff,\n    1851px 823px #fff,\n    1062px 100px #fff,\n    1220px 953px #fff,\n    20px 1826px #fff,\n    36px 1063px #fff,\n    1525px 338px #fff,\n    790px 1521px #fff,\n    741px 1099px #fff,\n    288px 1489px #fff,\n    700px 1060px #fff,\n    390px 1071px #fff,\n    411px 1036px #fff,\n    1853px 1072px #fff,\n    1446px 1085px #fff,\n    1164px 874px #fff,\n    924px 925px #fff,\n    291px 271px #fff,\n    1257px 1964px #fff,\n    1580px 1352px #fff,\n    1507px 1216px #fff,\n    211px 956px #fff,\n    985px 1195px #fff,\n    975px 1640px #fff,\n    518px 101px #fff,\n    663px 1395px #fff,\n    914px 532px #fff,\n    145px 1320px #fff,\n    69px 1397px #fff,\n    982px 523px #fff,\n    257px 725px #fff,\n    1599px 831px #fff,\n    1636px 1513px #fff,\n    1250px 1158px #fff,\n    1132px 604px #fff,\n    183px 102px #fff,\n    1057px 318px #fff,\n    1247px 1835px #fff,\n    1983px 1110px #fff,\n    1077px 1455px #fff,\n    921px 1770px #fff,\n    806px 1350px #fff,\n    1938px 1992px #fff,\n    855px 1260px #fff,\n    902px 1345px #fff,\n    658px 1908px #fff,\n    1845px 679px #fff,\n    712px 1482px #fff,\n    595px 950px #fff,\n    1784px 1992px #fff,\n    1847px 1785px #fff,\n    691px 1004px #fff,\n    175px 1179px #fff,\n    1666px 1911px #fff,\n    41px 61px #fff,\n    971px 1080px #fff,\n    1830px 1450px #fff,\n    1351px 1518px #fff,\n    1257px 99px #fff,\n    1395px 1498px #fff,\n    1117px 252px #fff,\n    1779px 597px #fff,\n    1346px 729px #fff,\n    1108px 1144px #fff,\n    402px 691px #fff,\n    72px 496px #fff,\n    1673px 1604px #fff,\n    1497px 974px #fff,\n    1865px 1664px #fff,\n    88px 806px #fff,\n    918px 77px #fff,\n    244px 1118px #fff,\n    256px 1820px #fff,\n    1851px 1840px #fff,\n    605px 1851px #fff,\n    634px 383px #fff,\n    865px 37px #fff,\n    943px 1024px #fff,\n    1951px 177px #fff,\n    1097px 523px #fff,\n    985px 1700px #fff,\n    1243px 122px #fff,\n    768px 1070px #fff,\n    468px 194px #fff,\n    320px 1867px #fff,\n    1850px 185px #fff,\n    380px 1616px #fff,\n    468px 1294px #fff,\n    1122px 1743px #fff,\n    884px 299px #fff,\n    1300px 1917px #fff,\n    1860px 396px #fff,\n    1270px 990px #fff,\n    529px 733px #fff,\n    1975px 1347px #fff,\n    1885px 685px #fff,\n    226px 506px #fff,\n    651px 878px #fff,\n    1323px 680px #fff,\n    1284px 680px #fff,\n    238px 1967px #fff,\n    911px 174px #fff,\n    1111px 521px #fff,\n    1150px 85px #fff,\n    794px 502px #fff,\n    484px 1856px #fff,\n    1809px 368px #fff,\n    112px 953px #fff,\n    590px 1009px #fff,\n    1655px 311px #fff,\n    100px 1026px #fff,\n    1803px 352px #fff,\n    865px 306px #fff,\n    1077px 1019px #fff,\n    1335px 872px #fff,\n    1647px 1298px #fff,\n    1233px 1387px #fff,\n    698px 1036px #fff,\n    659px 1860px #fff,\n    388px 1412px #fff,\n    1212px 458px #fff,\n    755px 1468px #fff,\n    696px 1654px #fff,\n    1144px 60px #fff;\n}\n\n#stars:after {\n  content: \"\";\n  position: absolute;\n  top: 2000px;\n  width: 1px;\n  height: 1px;\n  background: transparent;\n  box-shadow:\n    779px 1331px #fff,\n    324px 42px #fff,\n    303px 586px #fff,\n    1312px 276px #fff,\n    451px 625px #fff,\n    521px 1931px #fff,\n    1087px 1871px #fff,\n    36px 1546px #fff,\n    132px 934px #fff,\n    1698px 901px #fff,\n    1418px 664px #fff,\n    1448px 1157px #fff,\n    1084px 232px #fff,\n    347px 1776px #fff,\n    1722px 243px #fff,\n    1629px 835px #fff,\n    479px 969px #fff,\n    1231px 960px #fff,\n    586px 384px #fff,\n    164px 527px #fff,\n    8px 646px #fff,\n    1150px 1126px #fff,\n    665px 1357px #fff,\n    1556px 1982px #fff,\n    1260px 1961px #fff,\n    1675px 1741px #fff,\n    1843px 1514px #fff,\n    718px 1628px #fff,\n    242px 1343px #fff,\n    1497px 1880px #fff,\n    1364px 230px #fff,\n    1739px 1302px #fff,\n    636px 959px #fff,\n    304px 686px #fff,\n    614px 751px #fff,\n    1935px 816px #fff,\n    1428px 60px #fff,\n    355px 335px #fff,\n    1594px 158px #fff,\n    90px 60px #fff,\n    1553px 162px #fff,\n    1239px 1825px #fff,\n    1945px 587px #fff,\n    749px 1785px #fff,\n    1987px 1172px #fff,\n    1301px 1237px #fff,\n    1039px 342px #fff,\n    1585px 1481px #fff,\n    995px 1048px #fff,\n    524px 932px #fff,\n    214px 413px #fff,\n    1701px 1300px #fff,\n    1037px 1613px #fff,\n    1871px 996px #fff,\n    1360px 1635px #fff,\n    1110px 1313px #fff,\n    412px 1783px #fff,\n    1949px 177px #fff,\n    903px 1854px #fff,\n    700px 1936px #fff,\n    378px 125px #fff,\n    308px 834px #fff,\n    1118px 962px #fff,\n    1350px 1929px #fff,\n    781px 1811px #fff,\n    561px 137px #fff,\n    757px 1148px #fff,\n    1670px 1979px #fff,\n    343px 739px #fff,\n    945px 795px #fff,\n    576px 1903px #fff,\n    1078px 1436px #fff,\n    1583px 450px #fff,\n    1366px 474px #fff,\n    297px 1873px #fff,\n    192px 162px #fff,\n    1624px 1633px #fff,\n    59px 453px #fff,\n    82px 1872px #fff,\n    1933px 498px #fff,\n    1966px 1974px #fff,\n    1975px 1688px #fff,\n    779px 314px #fff,\n    1858px 1543px #fff,\n    73px 1507px #fff,\n    1693px 975px #fff,\n    1683px 108px #fff,\n    1768px 1654px #fff,\n    654px 14px #fff,\n    494px 171px #fff,\n    1689px 1895px #fff,\n    1660px 263px #fff,\n    1031px 903px #fff,\n    1203px 1393px #fff,\n    1333px 1421px #fff,\n    1113px 41px #fff,\n    1206px 1645px #fff,\n    1325px 1635px #fff,\n    142px 388px #fff,\n    572px 215px #fff,\n    1535px 296px #fff,\n    1419px 407px #fff,\n    1379px 1003px #fff,\n    329px 469px #fff,\n    1791px 1652px #fff,\n    935px 1802px #fff,\n    1330px 1820px #fff,\n    421px 1933px #fff,\n    828px 365px #fff,\n    275px 316px #fff,\n    707px 960px #fff,\n    1605px 1554px #fff,\n    625px 58px #fff,\n    717px 1697px #fff,\n    1669px 246px #fff,\n    1925px 322px #fff,\n    1154px 1803px #fff,\n    1929px 295px #fff,\n    1248px 240px #fff,\n    1045px 1755px #fff,\n    166px 942px #fff,\n    1888px 1773px #fff,\n    678px 1963px #fff,\n    1370px 569px #fff,\n    1974px 1400px #fff,\n    1786px 460px #fff,\n    51px 307px #fff,\n    784px 1400px #fff,\n    730px 1258px #fff,\n    1712px 393px #fff,\n    416px 170px #fff,\n    1797px 1932px #fff,\n    572px 219px #fff,\n    1557px 1856px #fff,\n    218px 8px #fff,\n    348px 1334px #fff,\n    469px 413px #fff,\n    385px 1738px #fff,\n    1357px 1818px #fff,\n    240px 942px #fff,\n    248px 1847px #fff,\n    1535px 806px #fff,\n    236px 1514px #fff,\n    1429px 1556px #fff,\n    73px 1633px #fff,\n    1398px 1121px #fff,\n    671px 1301px #fff,\n    1404px 1663px #fff,\n    740px 1018px #fff,\n    1600px 377px #fff,\n    785px 514px #fff,\n    112px 1084px #fff,\n    1915px 1887px #fff,\n    1463px 1848px #fff,\n    687px 1115px #fff,\n    1268px 1768px #fff,\n    1729px 1425px #fff,\n    1284px 1022px #fff,\n    801px 974px #fff,\n    1975px 1317px #fff,\n    1354px 834px #fff,\n    1446px 1484px #fff,\n    1283px 1786px #fff,\n    11px 523px #fff,\n    1842px 236px #fff,\n    1355px 654px #fff,\n    429px 7px #fff,\n    1033px 1128px #fff,\n    157px 297px #fff,\n    545px 635px #fff,\n    52px 1080px #fff,\n    827px 1520px #fff,\n    1121px 490px #fff,\n    9px 309px #fff,\n    1744px 1586px #fff,\n    1014px 417px #fff,\n    1534px 524px #fff,\n    958px 552px #fff,\n    1403px 1496px #fff,\n    387px 703px #fff,\n    1522px 548px #fff,\n    1355px 282px #fff,\n    1532px 601px #fff,\n    1838px 790px #fff,\n    290px 259px #fff,\n    295px 598px #fff,\n    1601px 539px #fff,\n    1561px 1272px #fff,\n    34px 1922px #fff,\n    1024px 543px #fff,\n    467px 369px #fff,\n    722px 333px #fff,\n    1976px 1255px #fff,\n    766px 983px #fff,\n    1582px 1285px #fff,\n    12px 512px #fff,\n    617px 1410px #fff,\n    682px 577px #fff,\n    1334px 1438px #fff,\n    439px 327px #fff,\n    1617px 1661px #fff,\n    673px 129px #fff,\n    794px 941px #fff,\n    1386px 1902px #fff,\n    37px 1353px #fff,\n    1467px 1353px #fff,\n    416px 18px #fff,\n    187px 344px #fff,\n    200px 1898px #fff,\n    1491px 1619px #fff,\n    811px 347px #fff,\n    924px 1827px #fff,\n    945px 217px #fff,\n    1735px 1228px #fff,\n    379px 1890px #fff,\n    79px 761px #fff,\n    825px 1837px #fff,\n    1980px 1558px #fff,\n    1308px 1573px #fff,\n    1488px 1726px #fff,\n    382px 1208px #fff,\n    522px 595px #fff,\n    1277px 1898px #fff,\n    354px 552px #fff,\n    161px 1784px #fff,\n    614px 251px #fff,\n    526px 1576px #fff,\n    17px 212px #fff,\n    179px 996px #fff,\n    467px 1208px #fff,\n    1944px 1838px #fff,\n    1140px 1093px #fff,\n    858px 1007px #fff,\n    200px 1064px #fff,\n    423px 1964px #fff,\n    1945px 439px #fff,\n    1377px 689px #fff,\n    1120px 1437px #fff,\n    1876px 668px #fff,\n    907px 1324px #fff,\n    343px 1976px #fff,\n    1816px 1501px #fff,\n    1849px 177px #fff,\n    647px 91px #fff,\n    1984px 1012px #fff,\n    1336px 1300px #fff,\n    128px 648px #fff,\n    305px 1060px #fff,\n    1324px 826px #fff,\n    1263px 1314px #fff,\n    1801px 629px #fff,\n    1614px 1555px #fff,\n    1634px 90px #fff,\n    1603px 452px #fff,\n    891px 1984px #fff,\n    1556px 1906px #fff,\n    121px 68px #fff,\n    1676px 1714px #fff,\n    516px 936px #fff,\n    1947px 1492px #fff,\n    1455px 1519px #fff,\n    45px 602px #fff,\n    205px 1039px #fff,\n    793px 172px #fff,\n    1562px 1739px #fff,\n    1056px 110px #fff,\n    1512px 379px #fff,\n    1795px 1621px #fff,\n    1848px 607px #fff,\n    262px 1719px #fff,\n    477px 991px #fff,\n    483px 883px #fff,\n    1239px 1197px #fff,\n    1496px 647px #fff,\n    1649px 25px #fff,\n    1491px 1946px #fff,\n    119px 996px #fff,\n    179px 1472px #fff,\n    1341px 808px #fff,\n    1565px 1700px #fff,\n    407px 1544px #fff,\n    1754px 357px #fff,\n    1288px 981px #fff,\n    902px 1997px #fff,\n    1755px 1668px #fff,\n    186px 877px #fff,\n    1202px 1882px #fff,\n    461px 1213px #fff,\n    1400px 748px #fff,\n    1969px 1899px #fff,\n    809px 522px #fff,\n    514px 1219px #fff,\n    374px 275px #fff,\n    938px 1973px #fff,\n    357px 552px #fff,\n    144px 1722px #fff,\n    1572px 912px #fff,\n    402px 1858px #fff,\n    1544px 1195px #fff,\n    667px 1257px #fff,\n    727px 1496px #fff,\n    993px 232px #fff,\n    1772px 313px #fff,\n    1040px 1590px #fff,\n    1204px 1973px #fff,\n    1268px 79px #fff,\n    1555px 1048px #fff,\n    986px 1707px #fff,\n    978px 1710px #fff,\n    713px 360px #fff,\n    407px 863px #fff,\n    461px 736px #fff,\n    284px 1608px #fff,\n    103px 430px #fff,\n    1283px 1319px #fff,\n    977px 1186px #fff,\n    1966px 1516px #fff,\n    1287px 1129px #fff,\n    70px 1098px #fff,\n    1189px 889px #fff,\n    1126px 1734px #fff,\n    309px 1292px #fff,\n    879px 764px #fff,\n    65px 473px #fff,\n    1003px 1959px #fff,\n    658px 791px #fff,\n    402px 1576px #fff,\n    35px 622px #fff,\n    529px 1589px #fff,\n    164px 666px #fff,\n    1876px 1290px #fff,\n    1541px 526px #fff,\n    270px 1297px #fff,\n    440px 865px #fff,\n    1500px 802px #fff,\n    182px 1754px #fff,\n    1264px 892px #fff,\n    272px 1249px #fff,\n    1289px 1535px #fff,\n    190px 1646px #fff,\n    955px 242px #fff,\n    1456px 1597px #fff,\n    1727px 1983px #fff,\n    635px 801px #fff,\n    226px 455px #fff,\n    1396px 1710px #fff,\n    849px 1863px #fff,\n    237px 1264px #fff,\n    839px 140px #fff,\n    1122px 735px #fff,\n    1280px 15px #fff,\n    1318px 242px #fff,\n    1819px 1148px #fff,\n    333px 1392px #fff,\n    1949px 553px #fff,\n    1878px 1332px #fff,\n    467px 548px #fff,\n    1812px 1082px #fff,\n    1067px 193px #fff,\n    243px 156px #fff,\n    483px 1616px #fff,\n    1714px 933px #fff,\n    759px 1800px #fff,\n    1822px 995px #fff,\n    1877px 572px #fff,\n    581px 1084px #fff,\n    107px 732px #fff,\n    642px 1837px #fff,\n    166px 1493px #fff,\n    1555px 198px #fff,\n    819px 307px #fff,\n    947px 345px #fff,\n    827px 224px #fff,\n    927px 1394px #fff,\n    540px 467px #fff,\n    1093px 405px #fff,\n    1140px 927px #fff,\n    130px 529px #fff,\n    33px 1980px #fff,\n    1147px 1663px #fff,\n    1616px 1436px #fff,\n    528px 710px #fff,\n    798px 1100px #fff,\n    505px 1480px #fff,\n    899px 641px #fff,\n    1909px 1949px #fff,\n    1311px 964px #fff,\n    979px 1301px #fff,\n    1393px 969px #fff,\n    1793px 1886px #fff,\n    292px 357px #fff,\n    1196px 1718px #fff,\n    1290px 1994px #fff,\n    537px 1973px #fff,\n    1181px 1674px #fff,\n    1740px 1566px #fff,\n    1307px 265px #fff,\n    922px 522px #fff,\n    1892px 472px #fff,\n    384px 1746px #fff,\n    392px 1098px #fff,\n    647px 548px #fff,\n    390px 1498px #fff,\n    1246px 138px #fff,\n    730px 876px #fff,\n    192px 1472px #fff,\n    1790px 1789px #fff,\n    928px 311px #fff,\n    1253px 1647px #fff,\n    747px 1921px #fff,\n    1561px 1025px #fff,\n    1533px 1292px #fff,\n    1985px 195px #fff,\n    728px 729px #fff,\n    1712px 1936px #fff,\n    512px 1717px #fff,\n    1528px 483px #fff,\n    313px 1642px #fff,\n    281px 1849px #fff,\n    1212px 799px #fff,\n    435px 1191px #fff,\n    1422px 611px #fff,\n    1718px 1964px #fff,\n    411px 944px #fff,\n    210px 636px #fff,\n    1502px 1295px #fff,\n    1434px 349px #fff,\n    769px 60px #fff,\n    747px 1053px #fff,\n    789px 504px #fff,\n    1436px 1264px #fff,\n    1893px 1225px #fff,\n    1394px 1788px #fff,\n    1108px 1317px #fff,\n    1673px 1395px #fff,\n    854px 1010px #fff,\n    1705px 80px #fff,\n    1858px 148px #fff,\n    1729px 344px #fff,\n    1388px 664px #fff,\n    895px 406px #fff,\n    1479px 157px #fff,\n    1441px 1157px #fff,\n    552px 1900px #fff,\n    516px 364px #fff,\n    1647px 189px #fff,\n    1427px 1071px #fff,\n    785px 729px #fff,\n    1080px 1710px #fff,\n    504px 204px #fff,\n    1177px 1622px #fff,\n    657px 34px #fff,\n    1296px 1099px #fff,\n    248px 180px #fff,\n    1212px 1568px #fff,\n    667px 1562px #fff,\n    695px 841px #fff,\n    1608px 1247px #fff,\n    751px 882px #fff,\n    87px 167px #fff,\n    607px 1368px #fff,\n    1363px 1203px #fff,\n    1836px 317px #fff,\n    1668px 1703px #fff,\n    830px 1154px #fff,\n    1721px 1398px #fff,\n    1601px 1280px #fff,\n    976px 874px #fff,\n    1743px 254px #fff,\n    1020px 1815px #fff,\n    1670px 1766px #fff,\n    1890px 735px #fff,\n    1379px 136px #fff,\n    1864px 695px #fff,\n    206px 965px #fff,\n    1404px 1932px #fff,\n    1923px 1360px #fff,\n    247px 682px #fff,\n    519px 1708px #fff,\n    645px 750px #fff,\n    1164px 1204px #fff,\n    834px 323px #fff,\n    172px 1350px #fff,\n    213px 972px #fff,\n    1837px 190px #fff,\n    285px 1806px #fff,\n    1047px 1299px #fff,\n    1548px 825px #fff,\n    1730px 324px #fff,\n    1346px 1909px #fff,\n    772px 270px #fff,\n    345px 1190px #fff,\n    478px 1433px #fff,\n    1479px 25px #fff,\n    1994px 1830px #fff,\n    1744px 732px #fff,\n    20px 1635px #fff,\n    690px 1795px #fff,\n    1594px 569px #fff,\n    579px 245px #fff,\n    1398px 733px #fff,\n    408px 1352px #fff,\n    1774px 120px #fff,\n    1152px 1370px #fff,\n    1698px 1810px #fff,\n    710px 1450px #fff,\n    665px 286px #fff,\n    493px 1720px #fff,\n    786px 5px #fff,\n    637px 1140px #fff,\n    764px 324px #fff,\n    927px 310px #fff,\n    938px 1424px #fff,\n    1884px 744px #fff,\n    913px 462px #fff,\n    1831px 1936px #fff,\n    1527px 249px #fff,\n    36px 1381px #fff,\n    1597px 581px #fff,\n    1530px 355px #fff,\n    949px 459px #fff,\n    799px 828px #fff,\n    242px 1471px #fff,\n    654px 797px #fff,\n    796px 594px #fff,\n    1365px 678px #fff,\n    752px 23px #fff,\n    1630px 541px #fff,\n    982px 72px #fff,\n    1733px 1831px #fff,\n    21px 412px #fff,\n    775px 998px #fff,\n    335px 1945px #fff,\n    264px 583px #fff,\n    158px 1311px #fff,\n    528px 164px #fff,\n    1978px 574px #fff,\n    717px 1203px #fff,\n    734px 1591px #fff,\n    1555px 820px #fff,\n    16px 1943px #fff,\n    1625px 1177px #fff,\n    1236px 690px #fff,\n    1585px 1590px #fff,\n    1737px 1728px #fff,\n    721px 698px #fff,\n    1804px 1186px #fff,\n    166px 980px #fff,\n    1850px 230px #fff,\n    330px 1712px #fff,\n    95px 797px #fff,\n    1948px 1078px #fff,\n    469px 939px #fff,\n    1269px 1899px #fff,\n    955px 1220px #fff,\n    1137px 1075px #fff,\n    312px 1293px #fff,\n    986px 1762px #fff,\n    1103px 1238px #fff,\n    428px 1993px #fff,\n    355px 570px #fff,\n    977px 1836px #fff,\n    1395px 1092px #fff,\n    276px 913px #fff,\n    1743px 656px #fff,\n    773px 502px #fff,\n    1686px 1322px #fff,\n    1516px 1945px #fff,\n    1334px 501px #fff,\n    266px 156px #fff,\n    455px 655px #fff,\n    798px 72px #fff,\n    1059px 1259px #fff,\n    1402px 1687px #fff,\n    236px 1329px #fff,\n    1455px 786px #fff,\n    146px 1228px #fff,\n    1851px 823px #fff,\n    1062px 100px #fff,\n    1220px 953px #fff,\n    20px 1826px #fff,\n    36px 1063px #fff,\n    1525px 338px #fff,\n    790px 1521px #fff,\n    741px 1099px #fff,\n    288px 1489px #fff,\n    700px 1060px #fff,\n    390px 1071px #fff,\n    411px 1036px #fff,\n    1853px 1072px #fff,\n    1446px 1085px #fff,\n    1164px 874px #fff,\n    924px 925px #fff,\n    291px 271px #fff,\n    1257px 1964px #fff,\n    1580px 1352px #fff,\n    1507px 1216px #fff,\n    211px 956px #fff,\n    985px 1195px #fff,\n    975px 1640px #fff,\n    518px 101px #fff,\n    663px 1395px #fff,\n    914px 532px #fff,\n    145px 1320px #fff,\n    69px 1397px #fff,\n    982px 523px #fff,\n    257px 725px #fff,\n    1599px 831px #fff,\n    1636px 1513px #fff,\n    1250px 1158px #fff,\n    1132px 604px #fff,\n    183px 102px #fff,\n    1057px 318px #fff,\n    1247px 1835px #fff,\n    1983px 1110px #fff,\n    1077px 1455px #fff,\n    921px 1770px #fff,\n    806px 1350px #fff,\n    1938px 1992px #fff,\n    855px 1260px #fff,\n    902px 1345px #fff,\n    658px 1908px #fff,\n    1845px 679px #fff,\n    712px 1482px #fff,\n    595px 950px #fff,\n    1784px 1992px #fff,\n    1847px 1785px #fff,\n    691px 1004px #fff,\n    175px 1179px #fff,\n    1666px 1911px #fff,\n    41px 61px #fff,\n    971px 1080px #fff,\n    1830px 1450px #fff,\n    1351px 1518px #fff,\n    1257px 99px #fff,\n    1395px 1498px #fff,\n    1117px 252px #fff,\n    1779px 597px #fff,\n    1346px 729px #fff,\n    1108px 1144px #fff,\n    402px 691px #fff,\n    72px 496px #fff,\n    1673px 1604px #fff,\n    1497px 974px #fff,\n    1865px 1664px #fff,\n    88px 806px #fff,\n    918px 77px #fff,\n    244px 1118px #fff,\n    256px 1820px #fff,\n    1851px 1840px #fff,\n    605px 1851px #fff,\n    634px 383px #fff,\n    865px 37px #fff,\n    943px 1024px #fff,\n    1951px 177px #fff,\n    1097px 523px #fff,\n    985px 1700px #fff,\n    1243px 122px #fff,\n    768px 1070px #fff,\n    468px 194px #fff,\n    320px 1867px #fff,\n    1850px 185px #fff,\n    380px 1616px #fff,\n    468px 1294px #fff,\n    1122px 1743px #fff,\n    884px 299px #fff,\n    1300px 1917px #fff,\n    1860px 396px #fff,\n    1270px 990px #fff,\n    529px 733px #fff,\n    1975px 1347px #fff,\n    1885px 685px #fff,\n    226px 506px #fff,\n    651px 878px #fff,\n    1323px 680px #fff,\n    1284px 680px #fff,\n    238px 1967px #fff,\n    911px 174px #fff,\n    1111px 521px #fff,\n    1150px 85px #fff,\n    794px 502px #fff,\n    484px 1856px #fff,\n    1809px 368px #fff,\n    112px 953px #fff,\n    590px 1009px #fff,\n    1655px 311px #fff,\n    100px 1026px #fff,\n    1803px 352px #fff,\n    865px 306px #fff,\n    1077px 1019px #fff,\n    1335px 872px #fff,\n    1647px 1298px #fff,\n    1233px 1387px #fff,\n    698px 1036px #fff,\n    659px 1860px #fff,\n    388px 1412px #fff,\n    1212px 458px #fff,\n    755px 1468px #fff,\n    696px 1654px #fff,\n    1144px 60px #fff;\n}\n\n#stars2 {\n  width: 2px;\n  height: 2px;\n  z-index: -100;\n  background: transparent;\n  animation: animStar 100s linear infinite;\n  box-shadow:\n    1448px 320px #fff,\n    1775px 1663px #fff,\n    332px 1364px #fff,\n    878px 340px #fff,\n    569px 1832px #fff,\n    1422px 1684px #fff,\n    1946px 1907px #fff,\n    121px 979px #fff,\n    1044px 1069px #fff,\n    463px 381px #fff,\n    423px 112px #fff,\n    523px 1179px #fff,\n    779px 654px #fff,\n    1398px 694px #fff,\n    1085px 1464px #fff,\n    1599px 1869px #fff,\n    801px 1882px #fff,\n    779px 1231px #fff,\n    552px 932px #fff,\n    1057px 1196px #fff,\n    282px 1280px #fff,\n    496px 1986px #fff,\n    1833px 1120px #fff,\n    1802px 1293px #fff,\n    6px 1696px #fff,\n    412px 1902px #fff,\n    605px 438px #fff,\n    24px 1212px #fff,\n    234px 1320px #fff,\n    544px 344px #fff,\n    1107px 170px #fff,\n    1603px 196px #fff,\n    905px 648px #fff,\n    68px 1458px #fff,\n    649px 1969px #fff,\n    744px 675px #fff,\n    1127px 478px #fff,\n    714px 1814px #fff,\n    1486px 526px #fff,\n    270px 1636px #fff,\n    1931px 149px #fff,\n    1807px 378px #fff,\n    8px 390px #fff,\n    1415px 699px #fff,\n    1473px 1211px #fff,\n    1590px 141px #fff,\n    270px 1705px #fff,\n    69px 1423px #fff,\n    1108px 1053px #fff,\n    1946px 128px #fff,\n    371px 371px #fff,\n    1490px 220px #fff,\n    357px 1885px #fff,\n    363px 363px #fff,\n    1896px 1256px #fff,\n    1979px 1050px #fff,\n    947px 1342px #fff,\n    1754px 242px #fff,\n    514px 974px #fff,\n    65px 1477px #fff,\n    1840px 547px #fff,\n    950px 695px #fff,\n    459px 1150px #fff,\n    1124px 1502px #fff,\n    481px 940px #fff,\n    680px 839px #fff,\n    797px 1169px #fff,\n    1977px 1491px #fff,\n    734px 1724px #fff,\n    210px 298px #fff,\n    816px 628px #fff,\n    686px 770px #fff,\n    1721px 267px #fff,\n    1663px 511px #fff,\n    1481px 1141px #fff,\n    582px 248px #fff,\n    1308px 953px #fff,\n    628px 657px #fff,\n    897px 1535px #fff,\n    270px 931px #fff,\n    791px 467px #fff,\n    1336px 1732px #fff,\n    1013px 1653px #fff,\n    1911px 956px #fff,\n    587px 816px #fff,\n    83px 456px #fff,\n    930px 1478px #fff,\n    1587px 1694px #fff,\n    614px 1200px #fff,\n    302px 1782px #fff,\n    1711px 1432px #fff,\n    443px 904px #fff,\n    1666px 714px #fff,\n    1588px 1167px #fff,\n    273px 1075px #fff,\n    1679px 461px #fff,\n    721px 664px #fff,\n    1202px 10px #fff,\n    166px 1126px #fff,\n    331px 1628px #fff,\n    430px 1565px #fff,\n    1585px 509px #fff,\n    640px 38px #fff,\n    822px 837px #fff,\n    1760px 1664px #fff,\n    1122px 1458px #fff,\n    398px 131px #fff,\n    689px 285px #fff,\n    460px 652px #fff,\n    1627px 365px #fff,\n    348px 1648px #fff,\n    819px 1946px #fff,\n    981px 1917px #fff,\n    323px 76px #fff,\n    979px 684px #fff,\n    887px 536px #fff,\n    1348px 1596px #fff,\n    1055px 666px #fff,\n    1402px 1797px #fff,\n    1300px 1055px #fff,\n    937px 238px #fff,\n    1474px 1815px #fff,\n    1144px 1710px #fff,\n    1629px 1087px #fff,\n    911px 919px #fff,\n    771px 819px #fff,\n    403px 720px #fff,\n    163px 736px #fff,\n    1062px 238px #fff,\n    1774px 818px #fff,\n    1874px 1178px #fff,\n    1177px 699px #fff,\n    1244px 1244px #fff,\n    1371px 58px #fff,\n    564px 1515px #fff,\n    1824px 487px #fff,\n    929px 702px #fff,\n    394px 1348px #fff,\n    1161px 641px #fff,\n    219px 1841px #fff,\n    358px 941px #fff,\n    140px 1759px #fff,\n    1019px 1345px #fff,\n    274px 436px #fff,\n    1433px 1605px #fff,\n    1798px 1426px #fff,\n    294px 1848px #fff,\n    1681px 1877px #fff,\n    1344px 1824px #fff,\n    1439px 1632px #fff,\n    161px 1012px #fff,\n    1308px 588px #fff,\n    1789px 582px #fff,\n    721px 1910px #fff,\n    318px 218px #fff,\n    607px 319px #fff,\n    495px 535px #fff,\n    1552px 1575px #fff,\n    1562px 67px #fff,\n    403px 926px #fff,\n    1096px 1800px #fff,\n    1814px 1709px #fff,\n    1882px 1831px #fff,\n    533px 46px #fff,\n    823px 969px #fff,\n    530px 165px #fff,\n    1030px 352px #fff,\n    1681px 313px #fff,\n    338px 115px #fff,\n    1607px 211px #fff,\n    1718px 1184px #fff,\n    1589px 659px #fff,\n    278px 355px #fff,\n    464px 1464px #fff,\n    1165px 277px #fff,\n    950px 694px #fff,\n    1746px 293px #fff,\n    793px 911px #fff,\n    528px 773px #fff,\n    1883px 1694px #fff,\n    748px 182px #fff,\n    1924px 1531px #fff,\n    100px 636px #fff,\n    1473px 1445px #fff,\n    1264px 1244px #fff,\n    850px 1377px #fff,\n    987px 1976px #fff,\n    933px 1761px #fff,\n    922px 1270px #fff,\n    500px 396px #fff,\n    1324px 8px #fff,\n    1967px 1814px #fff,\n    1072px 1401px #fff,\n    961px 37px #fff,\n    156px 81px #fff,\n    1915px 502px #fff,\n    1076px 1846px #fff,\n    152px 1669px #fff,\n    986px 1529px #fff,\n    1667px 1137px #fff;\n}\n\n#stars2:after {\n  content: \"\";\n  position: absolute;\n  top: 2000px;\n  width: 2px;\n  height: 2px;\n  background: transparent;\n  box-shadow:\n    1448px 320px #fff,\n    1775px 1663px #fff,\n    332px 1364px #fff,\n    878px 340px #fff,\n    569px 1832px #fff,\n    1422px 1684px #fff,\n    1946px 1907px #fff,\n    121px 979px #fff,\n    1044px 1069px #fff,\n    463px 381px #fff,\n    423px 112px #fff,\n    523px 1179px #fff,\n    779px 654px #fff,\n    1398px 694px #fff,\n    1085px 1464px #fff,\n    1599px 1869px #fff,\n    801px 1882px #fff,\n    779px 1231px #fff,\n    552px 932px #fff,\n    1057px 1196px #fff,\n    282px 1280px #fff,\n    496px 1986px #fff,\n    1833px 1120px #fff,\n    1802px 1293px #fff,\n    6px 1696px #fff,\n    412px 1902px #fff,\n    605px 438px #fff,\n    24px 1212px #fff,\n    234px 1320px #fff,\n    544px 344px #fff,\n    1107px 170px #fff,\n    1603px 196px #fff,\n    905px 648px #fff,\n    68px 1458px #fff,\n    649px 1969px #fff,\n    744px 675px #fff,\n    1127px 478px #fff,\n    714px 1814px #fff,\n    1486px 526px #fff,\n    270px 1636px #fff,\n    1931px 149px #fff,\n    1807px 378px #fff,\n    8px 390px #fff,\n    1415px 699px #fff,\n    1473px 1211px #fff,\n    1590px 141px #fff,\n    270px 1705px #fff,\n    69px 1423px #fff,\n    1108px 1053px #fff,\n    1946px 128px #fff,\n    371px 371px #fff,\n    1490px 220px #fff,\n    357px 1885px #fff,\n    363px 363px #fff,\n    1896px 1256px #fff,\n    1979px 1050px #fff,\n    947px 1342px #fff,\n    1754px 242px #fff,\n    514px 974px #fff,\n    65px 1477px #fff,\n    1840px 547px #fff,\n    950px 695px #fff,\n    459px 1150px #fff,\n    1124px 1502px #fff,\n    481px 940px #fff,\n    680px 839px #fff,\n    797px 1169px #fff,\n    1977px 1491px #fff,\n    734px 1724px #fff,\n    210px 298px #fff,\n    816px 628px #fff,\n    686px 770px #fff,\n    1721px 267px #fff,\n    1663px 511px #fff,\n    1481px 1141px #fff,\n    582px 248px #fff,\n    1308px 953px #fff,\n    628px 657px #fff,\n    897px 1535px #fff,\n    270px 931px #fff,\n    791px 467px #fff,\n    1336px 1732px #fff,\n    1013px 1653px #fff,\n    1911px 956px #fff,\n    587px 816px #fff,\n    83px 456px #fff,\n    930px 1478px #fff,\n    1587px 1694px #fff,\n    614px 1200px #fff,\n    302px 1782px #fff,\n    1711px 1432px #fff,\n    443px 904px #fff,\n    1666px 714px #fff,\n    1588px 1167px #fff,\n    273px 1075px #fff,\n    1679px 461px #fff,\n    721px 664px #fff,\n    1202px 10px #fff,\n    166px 1126px #fff,\n    331px 1628px #fff,\n    430px 1565px #fff,\n    1585px 509px #fff,\n    640px 38px #fff,\n    822px 837px #fff,\n    1760px 1664px #fff,\n    1122px 1458px #fff,\n    398px 131px #fff,\n    689px 285px #fff,\n    460px 652px #fff,\n    1627px 365px #fff,\n    348px 1648px #fff,\n    819px 1946px #fff,\n    981px 1917px #fff,\n    323px 76px #fff,\n    979px 684px #fff,\n    887px 536px #fff,\n    1348px 1596px #fff,\n    1055px 666px #fff,\n    1402px 1797px #fff,\n    1300px 1055px #fff,\n    937px 238px #fff,\n    1474px 1815px #fff,\n    1144px 1710px #fff,\n    1629px 1087px #fff,\n    911px 919px #fff,\n    771px 819px #fff,\n    403px 720px #fff,\n    163px 736px #fff,\n    1062px 238px #fff,\n    1774px 818px #fff,\n    1874px 1178px #fff,\n    1177px 699px #fff,\n    1244px 1244px #fff,\n    1371px 58px #fff,\n    564px 1515px #fff,\n    1824px 487px #fff,\n    929px 702px #fff,\n    394px 1348px #fff,\n    1161px 641px #fff,\n    219px 1841px #fff,\n    358px 941px #fff,\n    140px 1759px #fff,\n    1019px 1345px #fff,\n    274px 436px #fff,\n    1433px 1605px #fff,\n    1798px 1426px #fff,\n    294px 1848px #fff,\n    1681px 1877px #fff,\n    1344px 1824px #fff,\n    1439px 1632px #fff,\n    161px 1012px #fff,\n    1308px 588px #fff,\n    1789px 582px #fff,\n    721px 1910px #fff,\n    318px 218px #fff,\n    607px 319px #fff,\n    495px 535px #fff,\n    1552px 1575px #fff,\n    1562px 67px #fff,\n    403px 926px #fff,\n    1096px 1800px #fff,\n    1814px 1709px #fff,\n    1882px 1831px #fff,\n    533px 46px #fff,\n    823px 969px #fff,\n    530px 165px #fff,\n    1030px 352px #fff,\n    1681px 313px #fff,\n    338px 115px #fff,\n    1607px 211px #fff,\n    1718px 1184px #fff,\n    1589px 659px #fff,\n    278px 355px #fff,\n    464px 1464px #fff,\n    1165px 277px #fff,\n    950px 694px #fff,\n    1746px 293px #fff,\n    793px 911px #fff,\n    528px 773px #fff,\n    1883px 1694px #fff,\n    748px 182px #fff,\n    1924px 1531px #fff,\n    100px 636px #fff,\n    1473px 1445px #fff,\n    1264px 1244px #fff,\n    850px 1377px #fff,\n    987px 1976px #fff,\n    933px 1761px #fff,\n    922px 1270px #fff,\n    500px 396px #fff,\n    1324px 8px #fff,\n    1967px 1814px #fff,\n    1072px 1401px #fff,\n    961px 37px #fff,\n    156px 81px #fff,\n    1915px 502px #fff,\n    1076px 1846px #fff,\n    152px 1669px #fff,\n    986px 1529px #fff,\n    1667px 1137px #fff;\n}\n\n#stars3 {\n  width: 3px;\n  height: 3px;\n  z-index: -100;\n  background: transparent;\n  animation: animStar 150s linear infinte;\n  box-shadow:\n    387px 1878px #fff,\n    760px 1564px #fff,\n    1487px 999px #fff,\n    948px 1828px #fff,\n    1977px 1001px #fff,\n    1284px 1963px #fff,\n    656px 284px #fff,\n    1268px 1635px #fff,\n    1820px 598px #fff,\n    642px 1900px #fff,\n    296px 57px #fff,\n    921px 1620px #fff,\n    476px 1858px #fff,\n    658px 613px #fff,\n    1171px 1363px #fff,\n    1419px 283px #fff,\n    1037px 731px #fff,\n    503px 663px #fff,\n    1562px 463px #fff,\n    383px 1197px #fff,\n    1171px 1233px #fff,\n    876px 1768px #fff,\n    856px 1615px #fff,\n    1375px 1924px #fff,\n    1725px 918px #fff,\n    952px 119px #fff,\n    768px 1212px #fff,\n    992px 1462px #fff,\n    1929px 717px #fff,\n    1947px 755px #fff,\n    1818px 1123px #fff,\n    1896px 1672px #fff,\n    460px 198px #fff,\n    256px 271px #fff,\n    752px 544px #fff,\n    1222px 1859px #fff,\n    1851px 443px #fff,\n    313px 1858px #fff,\n    709px 446px #fff,\n    1546px 697px #fff,\n    674px 1155px #fff,\n    1112px 130px #fff,\n    355px 1790px #fff,\n    1496px 974px #fff,\n    1696px 480px #fff,\n    1316px 1265px #fff,\n    1645px 1063px #fff,\n    1182px 237px #fff,\n    427px 1582px #fff,\n    859px 253px #fff,\n    458px 939px #fff,\n    1517px 1644px #fff,\n    1943px 60px #fff,\n    212px 1650px #fff,\n    966px 1786px #fff,\n    473px 712px #fff,\n    130px 76px #fff,\n    1417px 1186px #fff,\n    909px 1580px #fff,\n    1913px 762px #fff,\n    204px 1143px #fff,\n    1998px 1057px #fff,\n    1468px 1301px #fff,\n    144px 1676px #fff,\n    21px 1601px #fff,\n    382px 1362px #fff,\n    912px 753px #fff,\n    1488px 1405px #fff,\n    802px 156px #fff,\n    174px 550px #fff,\n    338px 1366px #fff,\n    1197px 774px #fff,\n    602px 486px #fff,\n    682px 1877px #fff,\n    348px 1503px #fff,\n    407px 1139px #fff,\n    950px 1400px #fff,\n    922px 1139px #fff,\n    1697px 293px #fff,\n    1238px 1281px #fff,\n    1038px 1197px #fff,\n    376px 1889px #fff,\n    1255px 1680px #fff,\n    1008px 1316px #fff,\n    1538px 1447px #fff,\n    1186px 874px #fff,\n    1967px 640px #fff,\n    1341px 19px #fff,\n    29px 1732px #fff,\n    16px 1650px #fff,\n    1021px 1075px #fff,\n    723px 424px #fff,\n    1175px 41px #fff,\n    494px 1957px #fff,\n    1296px 431px #fff,\n    175px 1507px #fff,\n    831px 121px #fff,\n    498px 1947px #fff,\n    617px 880px #fff,\n    240px 403px #fff;\n}\n\n#stars3:after {\n  content: \"\";\n  position: absolute;\n  top: 2000px;\n  width: 3px;\n  height: 3px;\n  background: transparent;\n  box-shadow:\n    387px 1878px #fff,\n    760px 1564px #fff,\n    1487px 999px #fff,\n    948px 1828px #fff,\n    1977px 1001px #fff,\n    1284px 1963px #fff,\n    656px 284px #fff,\n    1268px 1635px #fff,\n    1820px 598px #fff,\n    642px 1900px #fff,\n    296px 57px #fff,\n    921px 1620px #fff,\n    476px 1858px #fff,\n    658px 613px #fff,\n    1171px 1363px #fff,\n    1419px 283px #fff,\n    1037px 731px #fff,\n    503px 663px #fff,\n    1562px 463px #fff,\n    383px 1197px #fff,\n    1171px 1233px #fff,\n    876px 1768px #fff,\n    856px 1615px #fff,\n    1375px 1924px #fff,\n    1725px 918px #fff,\n    952px 119px #fff,\n    768px 1212px #fff,\n    992px 1462px #fff,\n    1929px 717px #fff,\n    1947px 755px #fff,\n    1818px 1123px #fff,\n    1896px 1672px #fff,\n    460px 198px #fff,\n    256px 271px #fff,\n    752px 544px #fff,\n    1222px 1859px #fff,\n    1851px 443px #fff,\n    313px 1858px #fff,\n    709px 446px #fff,\n    1546px 697px #fff,\n    674px 1155px #fff,\n    1112px 130px #fff,\n    355px 1790px #fff,\n    1496px 974px #fff,\n    1696px 480px #fff,\n    1316px 1265px #fff,\n    1645px 1063px #fff,\n    1182px 237px #fff,\n    427px 1582px #fff,\n    859px 253px #fff,\n    458px 939px #fff,\n    1517px 1644px #fff,\n    1943px 60px #fff,\n    212px 1650px #fff,\n    966px 1786px #fff,\n    473px 712px #fff,\n    130px 76px #fff,\n    1417px 1186px #fff,\n    909px 1580px #fff,\n    1913px 762px #fff,\n    204px 1143px #fff,\n    1998px 1057px #fff,\n    1468px 1301px #fff,\n    144px 1676px #fff,\n    21px 1601px #fff,\n    382px 1362px #fff,\n    912px 753px #fff,\n    1488px 1405px #fff,\n    802px 156px #fff,\n    174px 550px #fff,\n    338px 1366px #fff,\n    1197px 774px #fff,\n    602px 486px #fff,\n    682px 1877px #fff,\n    348px 1503px #fff,\n    407px 1139px #fff,\n    950px 1400px #fff,\n    922px 1139px #fff,\n    1697px 293px #fff,\n    1238px 1281px #fff,\n    1038px 1197px #fff,\n    376px 1889px #fff,\n    1255px 1680px #fff,\n    1008px 1316px #fff,\n    1538px 1447px #fff,\n    1186px 874px #fff,\n    1967px 640px #fff,\n    1341px 19px #fff,\n    29px 1732px #fff,\n    16px 1650px #fff,\n    1021px 1075px #fff,\n    723px 424px #fff,\n    1175px 41px #fff,\n    494px 1957px #fff,\n    1296px 431px #fff,\n    175px 1507px #fff,\n    831px 121px #fff,\n    498px 1947px #fff,\n    617px 880px #fff,\n    240px 403px #fff;\n}\n\n@keyframes animStar {\n  from {\n    transform: translateY(0px);\n  }\n  to {\n    transform: translateY(-2000px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
